import React, { useEffect, useMemo, useState } from 'react';
import { createWooCommerceOrder, getWooCommerceOrders, searchWooCommerceProducts, updateWooOrder } from '../components/woocommerceHelper';
import * as InternalOrderService from '../components/InternalOrderService';
import StoresHelper from '../components/storesHelper';
import axios from 'axios';
import { header } from '../components/header.encry';
import ExcelJS from 'exceljs';
import { toast } from 'react-toastify';
import { Button, TableContainer, Paper, TextField, MenuItem, Container, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Divider, Grid, Card, CardContent, List, ListItem, ListItemAvatar, Avatar, ListItemText, Stack, Chip, Tooltip, Checkbox, Autocomplete, Tabs, Tab, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PrintIcon from '@mui/icons-material/Print';
import RefreshIcon from '@mui/icons-material/Refresh';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import NoteIcon from '@mui/icons-material/Note';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ImageIcon from '@mui/icons-material/Image';

const DEFAULT_STATUSES = [
  // mapped to statuses accepted by the API
  'processing', 'on-hold', 'delivery-inroute', 'en-cours-de-produ', 'en-cours-prod-mp', 'pickup', 'waiting-delivery'
];

const STATUS_LABELS = {
  'en-cours-mp': 'En Cours (MP)',
  'pending': 'Attente paiement',
  'delivery-problem': 'Problème de livraison',
  'not-available': 'Client Injoignable',
  'waiting-delivery': 'Attente de livraison',
  'pickup': 'PickUp',
  'en-cours-de-produ': 'En cours de production',
  'en-cours-prod-mp': 'En cours de Production (MP)',
  'delivery-inroute': 'Livraison en cours',
  'failed': 'Échouée',
  'refunded': 'Remboursée',
  'cancelled': 'Annulée',
  'completed': 'Terminée',
  'on-hold': 'En attente',
  'accepte': 'En cours (Paiement accepté)',
  'capture': 'En cours (Paiement reçu)',
  'processing': 'En cours',
  'refuse': 'Paiement refusé',
  'refused-by': 'Refusé par Récepteur',
  // fallback mapping for some meta statuses
  'en-cours-mp': 'En Cours (MP)'
};

const STATUS_COLORS = {
  processing: '#aee14fff',
  'delivery-inroute': '#3B82F6',
  completed: '#242424ff',
  cancelled: '#EF4444',
  refunded: '#EF4444',
  failed: '#EF4444',
  pending: '#578fffff',
  'on-hold': '#cdb126ff',
  'waiting-delivery': '#F97316',
  pickup: '#7C3AED',
  'en-cours-de-produ': '#F59E0B',
  'en-cours-prod-mp': '#F59E0B',
  accepte: '#10B981',
  capture: '#10B981'
};

const PRODUCTION_STATUSES = ['en-cours-de-produ', 'en-cours-prod-mp'];
const PRODUCTION_DEFAULT_STORES = {
  'en-cours-de-produ': '6794efdb748a6934506e363d',
  'en-cours-prod-mp': '6794ef24748a6934506e363c'
};

const hexToRgba = (hex, alpha = 0.12) => {
  if (!hex) return `rgba(156,163,175,${alpha})`;
  // strip #
  const h = hex.replace('#', '');
  if (h.length === 3) {
    const r = parseInt(h[0] + h[0], 16);
    const g = parseInt(h[1] + h[1], 16);
    const b = parseInt(h[2] + h[2], 16);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  if (h.length >= 6) {
    const r = parseInt(h.substring(0,2), 16);
    const g = parseInt(h.substring(2,4), 16);
    const b = parseInt(h.substring(4,6), 16);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  return `rgba(156,163,175,${alpha})`;
};

// Morocco state mapping
const WC_MOROCCO_STATES = {
  'MA-01': 'Tanger-Tétouan-Al Hoceïma',
  'MA-02': "L'Oriental",
  'MA-03': 'Fès-Meknès',
  'MA-04': 'Rabat-Salé-Kénitra',
  'MA-05': 'Béni Mellal-Khénifra',
  'MA-06': 'Casablanca-Settat',
  'MA-07': 'Marrakech-Safi',
  'MA-08': 'Drâa-Tafilalet',
  'MA-09': 'Souss-Massa',
  'MA-10': 'Guelmim-Oued Noun',
  'MA-11': 'Laâyoune-Sakia El Hamra',
  'MA-12': 'Dakhla-Oued Ed-Dahab'
};

const WC_MOROCCO_CITIES_BY_STATE = {
  'MA-01': ['Tanger', 'Tétouan', 'Al Hoceïma', 'Larache', 'Chefchaouen', 'Assilah'],
  'MA-02': ['Oujda', 'Nador', 'Berkane', 'Taourirt', 'Jerada', 'Saïdia'],
  'MA-03': ['Fès', 'Meknès', 'Ifrane', 'Sefrou', 'Taza', 'Azrou'],
  'MA-04': ['Rabat', 'Salé', 'Kénitra', 'Skhirat', 'Témara', 'Sidi Kacem'],
  'MA-05': ['Béni Mellal', 'Khénifra', 'Fquih Ben Salah', 'Azilal', 'Kasba Tadla'],
  'MA-06': ['Casablanca', 'Dar Bouazza', 'Bouskoura', 'Mohammedia', 'Nouaceur', 'Berrechid', 'Settat', 'El Jadida'],
  'MA-07': ['Marrakech', 'Safi', 'Essaouira', 'El Kelâa des Sraghna', 'Youssoufia', 'Ben Guerir'],
  'MA-08': ['Errachidia', 'Ouarzazate', 'Midelt', 'Tinghir', 'Zagora'],
  'MA-09': ['Agadir', 'Inezgane', 'Aït Melloul', 'Taroudant', 'Tiznit'],
  'MA-10': ['Guelmim', 'Sidi Ifni', 'Tan-Tan'],
  'MA-11': ['Laâyoune', 'Boujdour', 'Tarfaya', 'Es-Semara'],
  'MA-12': ['Dakhla', 'Aousserd']
};

const WC_MOROCCO_CITY_OPTIONS = Object.entries(WC_MOROCCO_CITIES_BY_STATE).flatMap(([stateCode, cities]) =>
  cities.map((city) => ({
    city,
    stateCode,
    stateLabel: WC_MOROCCO_STATES[stateCode] || stateCode,
  }))
);

const buildInitialCreateOrderForm = () => ({
  first_name: '',
  last_name: '',
  address_1: '',
  state: 'MA-06',
  city: '',
  note: '',
  phone: '',
  delivery_date: '',
});

const getStateName = (stateCode) => {
  if (!stateCode) return '';
  return WC_MOROCCO_STATES[stateCode] || stateCode;
};

export default function WooOrdersView() {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [driverDialogOpen, setDriverDialogOpen] = useState(false);
  const [driversOptions, setDriversOptions] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
  const [storeDialogOpen, setStoreDialogOpen] = useState(false);
  const [storesOptions, setStoresOptions] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [pendingStatusToUpdate, setPendingStatusToUpdate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [assigningDriver, setAssigningDriver] = useState(false);
  const [sendingToInternal, setSendingToInternal] = useState(false);
  const [perPage, setPerPage] = useState(50);
  const [page, setPage] = useState(1); // 1-based for API
  const [total, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState(DEFAULT_STATUSES);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [internalOrdersMap, setInternalOrdersMap] = useState({});
  const [usersMap, setUsersMap] = useState({});
  const [internalOrdersDetailsMap, setInternalOrdersDetailsMap] = useState({});
  const [selectedDriverName, setSelectedDriverName] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [productSearchQuery, setProductSearchQuery] = useState('');
  const [driverFilter, setDriverFilter] = useState('');
  const [createOrderDialogOpen, setCreateOrderDialogOpen] = useState(false);
  const [createOrderSubmitting, setCreateOrderSubmitting] = useState(false);
  const [createdOrderResult, setCreatedOrderResult] = useState(null);
  const [createOrderForm, setCreateOrderForm] = useState(buildInitialCreateOrderForm);
  const [createOrderProducts, setCreateOrderProducts] = useState([]);
  const [createOrderFees, setCreateOrderFees] = useState([]);
  const [createProductSearch, setCreateProductSearch] = useState('');
  const [createProductOptions, setCreateProductOptions] = useState([]);
  const [createProductLoading, setCreateProductLoading] = useState(false);
  const [remotePrinters, setRemotePrinters] = useState([]);
  const [imagePrintDialogOpen, setImagePrintDialogOpen] = useState(false);
  const [imagePrintOrder, setImagePrintOrder] = useState(null);
  const [imagePrintPrinterUid, setImagePrintPrinterUid] = useState('');
  const [imagePrintPaperName, setImagePrintPaperName] = useState('');
  const [imagePrintSubmitting, setImagePrintSubmitting] = useState(false);
  const [deliveryDateDraft, setDeliveryDateDraft] = useState('');
  const [deliveryDateSaving, setDeliveryDateSaving] = useState(false);
  const [bulkSelectionModel, setBulkSelectionModel] = useState([]);
  const [bulkDialogOpen, setBulkDialogOpen] = useState(false);
  const [bulkStatus, setBulkStatus] = useState('');
  const [bulkStoreId, setBulkStoreId] = useState('');
  const [bulkDriverId, setBulkDriverId] = useState('');
  const [bulkStoresOptions, setBulkStoresOptions] = useState([]);
  const [bulkDriversOptions, setBulkDriversOptions] = useState([]);
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  const [bulkProgress, setBulkProgress] = useState({ completed: 0, total: 0 });
  const roles = useMemo(() => {
    try {
      const parsed = JSON.parse(sessionStorage.getItem('roles') || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }, []);
  const canChangeWooDeliveryDate = roles.some((role) => ['admin', 'manager', 'courier', 'driver'].includes(role));
  const canManagePendingPayments = roles.includes('admin') || roles.includes('manager');
  const visibleOrders = useMemo(
    () => (Array.isArray(orders) ? orders.filter((order) => canManagePendingPayments || order?.status !== 'pending') : []),
    [orders, canManagePendingPayments]
  );
  const fetchStatuses = useMemo(() => {
    const selected = Array.isArray(statusFilter) && statusFilter.length > 0 ? statusFilter : DEFAULT_STATUSES;
    return selected.filter((status) => canManagePendingPayments || status !== 'pending');
  }, [statusFilter, canManagePendingPayments]);
  const bulkSelectedOrders = useMemo(() => {
    const selectedIds = new Set((Array.isArray(bulkSelectionModel) ? bulkSelectionModel : []).map(String));
    return visibleOrders.filter((order) => selectedIds.has(String(order?.id)));
  }, [bulkSelectionModel, visibleOrders]);

  const canSetProductionStatus = (order, targetStatus) => (
    !PRODUCTION_STATUSES.includes(targetStatus) ||
    canManagePendingPayments ||
    order?.status === 'processing'
  );

  const normalizeId = (v) => {
    if (v === null || v === undefined) return '';
    if (typeof v === 'object') return v.$oid || v._id || v.id || v.value || '';
    return String(v);
  };

  const resetCreateOrderDialog = () => {
    setCreateOrderForm(buildInitialCreateOrderForm());
    setCreateOrderProducts([]);
    setCreateOrderFees([]);
    setCreateProductSearch('');
    setCreateProductOptions([]);
    setCreateProductLoading(false);
  };

  const openCreateOrderDialog = () => {
    resetCreateOrderDialog();
    setCreateOrderDialogOpen(true);
  };

  const closeCreateOrderDialog = () => {
    if (createOrderSubmitting) return;
    setCreateOrderDialogOpen(false);
    resetCreateOrderDialog();
  };

  const copyText = async (value, successMessage = 'Copié') => {
    const text = String(value || '').trim();
    if (!text) {
      toast.error('Aucune valeur à copier');
      return false;
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const input = document.createElement('textarea');
        input.value = text;
        input.setAttribute('readonly', '');
        input.style.position = 'absolute';
        input.style.left = '-9999px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
      toast.success(successMessage);
      return true;
    } catch (error) {
      console.error('Copy failed', error);
      toast.error('Impossible de copier');
      return false;
    }
  };

  const copyPaymentLink = async (paymentUrl) => copyText(paymentUrl, 'Lien de paiement copié');

  const handleCreateOrderFieldChange = (field, value) => {
    setCreateOrderForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCreateOrderCityChange = (cityValue) => {
    const selectedCity = WC_MOROCCO_CITY_OPTIONS.find((option) => option.city === cityValue);
    setCreateOrderForm((prev) => ({
      ...prev,
      city: cityValue,
      state: selectedCity?.stateCode || prev.state,
    }));
  };

  const addProductToDraftOrder = (product) => {
    if (!product?.id) {
      return;
    }

    setCreateOrderProducts((prev) => {
      const existing = prev.find((entry) => Number(entry.product_id) === Number(product.id));
      if (existing) {
        return prev.map((entry) =>
          Number(entry.product_id) === Number(product.id)
            ? { ...entry, quantity: Number(entry.quantity || 1) + 1 }
            : entry
        );
      }

      return [
        ...prev,
        {
          product_id: Number(product.id),
          name: product.name || `#${product.id}`,
          quantity: 1,
          price: Number(product.price || product.regular_price || 0),
          sku: product.sku || '',
          image: product.images?.[0]?.src || ''
        }
      ];
    });

    setCreateProductSearch('');
    setCreateProductOptions([]);
  };

  const updateDraftOrderProductQuantity = (productId, quantity) => {
    const normalizedQuantity = Math.max(1, Number(quantity) || 1);
    setCreateOrderProducts((prev) =>
      prev.map((entry) =>
        Number(entry.product_id) === Number(productId)
          ? { ...entry, quantity: normalizedQuantity }
          : entry
      )
    );
  };

  const updateDraftOrderProductPrice = (productId, price) => {
    const normalizedPrice = Math.max(0, Number(price) || 0);
    setCreateOrderProducts((prev) =>
      prev.map((entry) =>
        Number(entry.product_id) === Number(productId)
          ? { ...entry, price: normalizedPrice }
          : entry
      )
    );
  };

  const removeDraftOrderProduct = (productId) => {
    setCreateOrderProducts((prev) =>
      prev.filter((entry) => Number(entry.product_id) !== Number(productId))
    );
  };

  const addDraftFeeLine = () => {
    setCreateOrderFees((prev) => [...prev, { id: `${Date.now()}-${prev.length}`, name: '', total: '' }]);
  };

  const updateDraftFeeLine = (feeId, field, value) => {
    setCreateOrderFees((prev) =>
      prev.map((entry) => (entry.id === feeId ? { ...entry, [field]: value } : entry))
    );
  };

  const removeDraftFeeLine = (feeId) => {
    setCreateOrderFees((prev) => prev.filter((entry) => entry.id !== feeId));
  };

  const fetch = async () => {
    setLoading(true);
    try {
      const res = await getWooCommerceOrders({ statuses: fetchStatuses, per_page: perPage, page });
      const data = res && res.data ? res.data : (Array.isArray(res) ? res : []);
      setOrders(Array.isArray(data) ? data : []);
      setTotal(res && typeof res.total === 'number' ? res.total : (Array.isArray(data) ? data.length : 0));
      
      // Fetch full internal orders data to get orderStatus and other details
      try {
        const arr = Array.isArray(data) ? data : [];
        const codes = arr.map(o => String(o.id));
        
        // Fetch Site type orders (WooCommerce orders)
        const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
        const response = await axios.get(`${API_URL}/orders/type/Site?limit=1000`, header());
        const fetchedInternalOrders = response.data?.orders || (Array.isArray(response.data) ? response.data : []);
        
        // Build map with full order data keyed by orderCode
        const map = {};
        fetchedInternalOrders.forEach(order => {
          const orderCode = String(order.orderCode || order.orderNumber || '');
          if (orderCode && codes.includes(orderCode)) {
            map[orderCode] = order;
          }
        });
        
        setInternalOrdersMap(map);
        setInternalOrdersDetailsMap(map);
      } catch (e) {
        console.error('Failed to fetch internal orders:', e);
        setInternalOrdersMap({});
      }
    } catch (e) {
      console.error('woo orders fetch', e);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, [perPage, page, fetchStatuses]);

  useEffect(() => {
    if (createOrderForm.city) {
      return;
    }

    const defaultCity = (WC_MOROCCO_CITIES_BY_STATE[createOrderForm.state] || [])[0] || '';
    if (defaultCity) {
      setCreateOrderForm((prev) => ({ ...prev, city: defaultCity }));
    }
  }, [createOrderForm.state, createOrderForm.city]);

  useEffect(() => {
    if (!createOrderDialogOpen) {
      return undefined;
    }

    const query = String(createProductSearch || '').trim();
    if (query.length < 2) {
      setCreateProductOptions([]);
      setCreateProductLoading(false);
      return undefined;
    }

    let active = true;
    const timeoutId = setTimeout(async () => {
      setCreateProductLoading(true);
      try {
        const response = await searchWooCommerceProducts({ search: query, per_page: 20 });
        if (!active) {
          return;
        }
        setCreateProductOptions(Array.isArray(response?.data) ? response.data : []);
      } catch (error) {
        console.error('Failed to search WooCommerce products', error);
        if (active) {
          setCreateProductOptions([]);
        }
      } finally {
        if (active) {
          setCreateProductLoading(false);
        }
      }
    }, 350);

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [createOrderDialogOpen, createProductSearch]);

  // fetch users once to resolve driver names
  useEffect(() => {
    (async () => {
      try {
        const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
        const res = await axios.get(`${API_URL}/users`, header());
        const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
        const map = {};
        (list || []).forEach(u => {
          const rawId = u?._id || u?.id || u?.value || '';
          const id = normalizeId(rawId);
          const name = [u?.name, u?.lastname].filter(Boolean).join(' ') || u?.email || u?.username || '';
          if (id) map[String(id)] = { user_id: String(id), userfullname: name };
        });
        setUsersMap(map);
      } catch (e) {
        setUsersMap({});
      }
    })();
  }, []);

  // When orders update, ensure we have user details for any driver ids present
  useEffect(() => {
    if (!Array.isArray(orders) || !orders.length) return;
    (async () => {
      try {
        const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
        const missing = new Set();
        orders.forEach(o => {
          const raw = o?.affected?.driver_id || o?.driver_id || null;
          const key = normalizeId(raw);
          if (key && !usersMap[key]) missing.add(key);
        });
        if (!missing.size) return;
        await Promise.allSettled(Array.from(missing).map(async (id) => {
          try {
            const res = await axios.get(`${API_URL}/users/${id}`, header());
            const u = res?.data;
            if (u) {
              const uid = normalizeId(u?._id || u?.id || u?.value);
              const name = [u?.name, u?.lastname].filter(Boolean).join(' ') || u?.email || u?.username || '';
              setUsersMap(prev => ({ ...(prev||{}), [String(uid)]: { user_id: String(uid), userfullname: name } }));
            }
          } catch (e) {
            // ignore single failures
          }
        }));
      } catch (e) {
        // ignore
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  // Ensure we have full local internal-order details for any Woo orders
  // that exist in the internal DB (internalOrdersMap). We cache them in
  // `internalOrdersDetailsMap` keyed by the Woo order id so rendering can
  // prefer local order fields (like assigned driver) over the raw Woo order.
  useEffect(() => {
    if (!Array.isArray(orders) || !orders.length) return;
    (async () => {
      try {
        const toFetch = [];
        orders.forEach(o => {
          const id = o && o.id;
          if (!id) return;
          const exists = internalOrdersMap && internalOrdersMap[id];
          const already = internalOrdersDetailsMap && internalOrdersDetailsMap[id];
          if (exists && !already) toFetch.push(String(id));
        });
        if (!toFetch.length) return;
        await Promise.allSettled(toFetch.map(async (code) => {
          try {
            const res = await InternalOrderService.getOrderByCode(code);
            if (res) setInternalOrdersDetailsMap(prev => ({ ...(prev||{}), [code]: res }));
          } catch (e) {
            // ignore individual failures
          }
        }));
      } catch (e) {
        // ignore
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalOrdersMap, orders]);

  const printOrder = (order) => {
    try {
      const payload = { ...(order || {}), store: (order && order.store) || '' };
      localStorage.setItem('order', JSON.stringify(payload));
      window.open('/print-receipt', '_blank');
    } catch (e) {
      console.error('printOrder error', e);
    }
  };

  const parseDeliveryToDate = (deliveryStr) => {
    if (!deliveryStr) return null;
    // handle DD/MM/YYYY or ISO
    if (/\d{2}\/\d{2}\/\d{4}/.test(deliveryStr)) {
      const [d, m, y] = deliveryStr.split('/').map(Number);
      return new Date(y, m - 1, d);
    }
    const d = new Date(deliveryStr);
    return isNaN(d.getTime()) ? null : d;
  };

  const formatDateToDDMMYYYY = (value) => {
    if (!value) return '—';
    // If already in DD/MM/YYYY, return as-is
    if (typeof value === 'string' && /\d{2}\/\d{2}\/\d{4}/.test(value)) return value;
    const d = value instanceof Date ? value : parseDeliveryToDate(String(value));
    if (!d) return '—';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const formatDateToInputValue = (value) => {
    const parsed = parseDeliveryToDate(value);
    if (!parsed) return '';
    const yyyy = parsed.getFullYear();
    const mm = String(parsed.getMonth() + 1).padStart(2, '0');
    const dd = String(parsed.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const deliveryIndicator = (deliveryStr) => {
    const d = parseDeliveryToDate(deliveryStr);
    if (!d) return '';
    const today = new Date();
    today.setHours(0,0,0,0);
    const diff = Math.round((d - today) / (1000 * 60 * 60 * 24));
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow';
    if (diff < 0) return 'Late';
    return '';
  };

  const openOrderDialog = async (order) => {
    setSelectedOrder(order);
    setDeliveryDateDraft(formatDateToInputValue(getDeliveryDate(order)));
    setDialogOpen(true);
    setSelectedDriverName('');
    try {
      const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
      const res = await axios.get(`${API_URL}/users`, header());
      const list = Array.isArray(res?.data) ? res.data : (res?.data?.data || []);
      const map = {};
      (list || []).forEach(u => {
        const id = normalizeId(u?._id || u?.id || u?.value);
        const name = [u?.name, u?.lastname].filter(Boolean).join(' ') || u?.email || u?.username || '';
        if (id) map[String(id)] = { user_id: String(id), userfullname: name };
      });
      setUsersMap(map);

      // resolve driver id from order.affected
      const raw = order?.affected?.driver_id || order?.driver_id || null;
      const driverKey = normalizeId(raw);
      if (driverKey) {
        const found = map[String(driverKey)];
        const foundName = found ? (found.userfullname || found.user_id) : null;
        if (foundName) setSelectedDriverName(foundName);
      }
    } catch (e) {
      console.warn('Failed to fetch users for order dialog', e);
    }
  };

  const closeOrderDialog = () => {
    setSelectedOrder(null);
    setDeliveryDateDraft('');
    setDialogOpen(false);
  };

  const upsertOrderMeta = (metaData = [], entries = []) => {
    const nextMeta = Array.isArray(metaData) ? [...metaData] : [];
    entries.forEach(({ key, value }) => {
      const index = nextMeta.findIndex((item) => String(item?.key || '').toLowerCase() === String(key).toLowerCase());
      if (index >= 0) {
        nextMeta[index] = { ...nextMeta[index], key: nextMeta[index].key || key, value };
      } else {
        nextMeta.push({ key, value });
      }
    });
    return nextMeta;
  };

  const handleUpdateDeliveryDate = async () => {
    if (!selectedOrder || !canChangeWooDeliveryDate || !deliveryDateDraft) return;
    const formattedDeliveryDate = formatDateToDDMMYYYY(deliveryDateDraft);
    const metaEntries = [
      { key: 'Date de Livraison', value: formattedDeliveryDate },
      { key: '_orddd_delivery_date', value: formattedDeliveryDate },
      { key: 'delivery_date_locale', value: formattedDeliveryDate },
      { key: 'delivery_date_formatted', value: formattedDeliveryDate },
    ];

    setDeliveryDateSaving(true);
    try {
      const updatedOrder = await updateWooOrder(selectedOrder.id, { meta_data: metaEntries });
      const fallbackOrder = {
        ...selectedOrder,
        meta_data: upsertOrderMeta(selectedOrder.meta_data, metaEntries),
      };
      const normalizedUpdatedOrder = updatedOrder?.id ? updatedOrder : fallbackOrder;
      setSelectedOrder(normalizedUpdatedOrder);
      setOrders((prev) => prev.map((order) => (
        String(order.id) === String(selectedOrder.id) ? { ...order, ...normalizedUpdatedOrder } : order
      )));
      toast.success('Date de livraison mise à jour.');
    } catch (error) {
      console.error('Failed to update WooCommerce delivery date', error);
      toast.error('Impossible de modifier la date de livraison.');
    } finally {
      setDeliveryDateSaving(false);
    }
  };

  const openStatusDialog = () => {
    if (!selectedOrder) return;
    if (selectedOrder.status === 'pending' && !canManagePendingPayments) {
      toast.error("Seuls un manager ou un administrateur peuvent changer le statut d'une commande en attente de paiement.");
      return;
    }
    setNewStatus(selectedOrder.status || '');
    setStatusDialogOpen(true);
  };

  const closeStatusDialog = () => {
    setStatusDialogOpen(false);
    setNewStatus('');
  };

  const confirmUpdateStatus = async () => {
    if (!selectedOrder) return;
    if (selectedOrder.status === 'pending' && newStatus !== selectedOrder.status && !canManagePendingPayments) {
      toast.error("Seuls un manager ou un administrateur peuvent changer le statut d'une commande en attente de paiement.");
      closeStatusDialog();
      return;
    }
    if (!canSetProductionStatus(selectedOrder, newStatus)) {
      toast.error('Pour ce profil, la production peut uniquement être démarrée depuis le statut « En cours ».');
      closeStatusDialog();
      return;
    }
    try {
      // if status is one of the production statuses, prompt to add order to internal service
      if (PRODUCTION_STATUSES.includes(newStatus)) {
        // do NOT update remote yet — store pending status and open store dialog
        setPendingStatusToUpdate(newStatus);
        // default mappings for these statuses (store _id values)
        // fetch stores (distinct stores) and preselect glovo-type stores
        try {
          const stores = await StoresHelper();
          const glovoStores = Array.isArray(stores) ? stores.filter(s => (s.type || '').toLowerCase() === 'glovo') : [];
          setStoresOptions(glovoStores);
          const def = PRODUCTION_DEFAULT_STORES[newStatus];
          const found = glovoStores.find(s => String(s.id) === String(def) || String(s.value) === String(def));
          setSelectedStoreId(found ? (found.id || found.value) : (glovoStores[0] ? (glovoStores[0].id || glovoStores[0].value) : def));
        } catch (e) {
          setStoresOptions([]);
          setSelectedStoreId(PRODUCTION_DEFAULT_STORES[newStatus]);
        }
        // keep selected order updated locally and open store dialog to confirm sending
        setSelectedOrder(prev => prev ? { ...prev, status: newStatus } : prev);
        setStoreDialogOpen(true);
        closeStatusDialog();
        return;
      }

      // if changing to delivery-inroute, require driver assignment first
      if (newStatus === 'delivery-inroute') {
        // fetch drivers (users with access_permissions including 'driver')
        try {
          const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
          const res = await axios.get(`${API_URL}/users`, header());
          const list = res?.data || [];
          const drivers = Array.isArray(list) ? list.filter(u => Array.isArray(u.access_permissions) && u.access_permissions.includes('driver')) : [];
          setDriversOptions(drivers);
          setSelectedDriverId(drivers[0]?._id || drivers[0]?.id || null);
        } catch (e) {
          setDriversOptions([]);
          setSelectedDriverId(null);
        }
        setPendingStatusToUpdate(newStatus);
        setDriverDialogOpen(true);
        closeStatusDialog();
        return;
      }

      // non-production and non-delivery-inroute: update Woo directly (do NOT call centralized /orders/woo/status/driver)
      try {
        try {
          await updateWooOrder(selectedOrder.id, { status: newStatus });
        } catch (e) {
          console.error('Failed to update Woo order status', e);
          alert('Failed to update Woo order status');
        }
        // refresh list and update local selected order
        await fetch();
        setSelectedOrder(prev => prev ? { ...prev, status: newStatus } : prev);
        closeStatusDialog();
      } catch (err) {
        console.error('Failed to update status', err);
        alert('Failed to update order status');
      }
    } catch (e) {
      console.error('Failed to update status', e);
      alert('Failed to update order status');
    }
  };

  const closeDriverDialog = () => {
    setDriverDialogOpen(false);
    setDriversOptions([]);
    setSelectedDriverId(null);
  };

  const assignDriverAndUpdate = async () => {
    if (!selectedOrder || !selectedDriverId) return;
    if (assigningDriver) return;
    setAssigningDriver(true);
    try {
      const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
      const orderCode = String(selectedOrder.number || selectedOrder.id || selectedOrder.orderCode || '');
      // ensure local internal order exists
      let localOrder = null;
      try {
        localOrder = await InternalOrderService.getOrderByCode(orderCode);
      } catch (err) {
        localOrder = null;
      }
      if (!localOrder || !localOrder._id) {
        try {
          const created = await InternalOrderService.createFromWoo(selectedOrder, null);
          try { localOrder = await InternalOrderService.getOrderByCode(orderCode); } catch (e) { localOrder = created || null; }
        } catch (e) {
          localOrder = null;
        }
      }
      if (!localOrder || !localOrder._id) {
        throw new Error('Local internal order not found or created');
      }
      const localId = localOrder._id || localOrder.id;

      // assign driver locally so the internal order reflects assignment immediately
      try {
        await axios.patch(`${API_URL}/orders/${localId}/driver/${selectedDriverId}`, { status: 'ongoing' }, header());
      } catch (e) {
        console.warn('Failed to patch local order with driver, continuing to call status API', e);
      }

      // Call centralized status endpoint; ensure payload.orderId is the local internal order id
      if (pendingStatusToUpdate) {
        try {
          const payload = {
            orderId: localId || undefined,
            orderCode: orderCode || undefined,
            status: pendingStatusToUpdate || 'delivery-inroute',
            driver_id: selectedDriverId
          };
          await axios.post(`${API_URL}/orders/woo/status/driver`, payload, header());
        } catch (e) {
          console.error('Failed to call status API after assigning driver', e);
          alert('Driver assigned but failed to update order status via API');
        }
      }

      // refresh and update local state
      await fetch();
      setPendingStatusToUpdate(null);
      closeDriverDialog();
    } catch (e) {
      console.error('Failed to assign driver', e);
      alert('Failed to assign driver to order');
    }
    finally {
      setAssigningDriver(false);
    }
  };

  const closeStoreDialog = () => {
    setStoreDialogOpen(false);
    setStoresOptions([]);
    setSelectedStoreId(null);
  };

  const sendToInternal = async () => {
    if (!selectedOrder) return;
    if (sendingToInternal) return;
    setSendingToInternal(true);
    try {
      // create order in internal service using createFromWoo; pass selectedStoreId if present
      const created = await InternalOrderService.createFromWoo(selectedOrder, selectedStoreId || null);
      // if payload created and we have a pending remote status, update Woo now
      if (pendingStatusToUpdate) {
        try {
          await updateWooOrder(selectedOrder.id, { status: pendingStatusToUpdate });
        } catch (e) {
          console.error('Failed to update Woo after creating internal order', e);
          alert('Internal order created but failed to update Woo order status');
        }
      }
      // refresh list after creation/update
      await fetch();
      setPendingStatusToUpdate(null);
      closeStoreDialog();
    } catch (e) {
      console.error('Failed to send order to internal service', e);
      alert('Failed to add order to internal service');
    }
    finally {
      setSendingToInternal(false);
    }
  };

  const loadBulkStores = async (status) => {
    const defaultStoreId = PRODUCTION_DEFAULT_STORES[status] || '';
    try {
      const stores = await StoresHelper();
      const glovoStores = Array.isArray(stores)
        ? stores.filter((store) => String(store?.type || '').toLowerCase() === 'glovo')
        : [];
      setBulkStoresOptions(glovoStores);
      const defaultStore = glovoStores.find((store) => (
        String(store?.id || store?.value || '') === String(defaultStoreId)
      ));
      setBulkStoreId(defaultStore
        ? (defaultStore.id || defaultStore.value)
        : (glovoStores[0]?.id || glovoStores[0]?.value || defaultStoreId));
    } catch (error) {
      console.error('Failed to load stores for bulk WooCommerce update', error);
      setBulkStoresOptions([]);
      setBulkStoreId(defaultStoreId);
    }
  };

  const loadBulkDrivers = async () => {
    try {
      const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
      const response = await axios.get(`${API_URL}/users`, header());
      const drivers = Array.isArray(response?.data)
        ? response.data.filter((user) => Array.isArray(user?.access_permissions) && user.access_permissions.includes('driver'))
        : [];
      setBulkDriversOptions(drivers);
      setBulkDriverId(drivers[0]?._id || drivers[0]?.id || '');
    } catch (error) {
      console.error('Failed to load drivers for bulk WooCommerce update', error);
      setBulkDriversOptions([]);
      setBulkDriverId('');
    }
  };

  const openBulkDialog = () => {
    if (!bulkSelectedOrders.length) {
      toast.error('Sélectionnez au moins une commande.');
      return;
    }
    setBulkStatus('');
    setBulkStoreId('');
    setBulkDriverId('');
    setBulkStoresOptions([]);
    setBulkDriversOptions([]);
    setBulkProgress({ completed: 0, total: bulkSelectedOrders.length });
    setBulkDialogOpen(true);
  };

  const closeBulkDialog = () => {
    if (bulkSubmitting) return;
    setBulkDialogOpen(false);
    setBulkStatus('');
    setBulkStoreId('');
    setBulkDriverId('');
    setBulkProgress({ completed: 0, total: 0 });
  };

  const handleBulkStatusChange = async (status) => {
    setBulkStatus(status);
    setBulkStoreId('');
    setBulkDriverId('');
    setBulkStoresOptions([]);
    setBulkDriversOptions([]);
    if (PRODUCTION_STATUSES.includes(status)) {
      await loadBulkStores(status);
    } else if (status === 'delivery-inroute') {
      await loadBulkDrivers();
    }
  };

  const ensureBulkInternalOrder = async (order) => {
    const orderCode = String(order?.number || order?.id || order?.orderCode || '');
    let localOrder = null;
    try {
      localOrder = await InternalOrderService.getOrderByCode(orderCode);
    } catch (error) {
      localOrder = null;
    }
    if (!localOrder?._id) {
      const created = await InternalOrderService.createFromWoo(order, null);
      try {
        localOrder = await InternalOrderService.getOrderByCode(orderCode);
      } catch (error) {
        localOrder = created?.order || created || null;
      }
    }
    if (!localOrder?._id && !localOrder?.id) {
      throw new Error(`Commande interne introuvable pour #${orderCode}`);
    }
    return { localOrder, orderCode };
  };

  const applyBulkStatusUpdate = async () => {
    if (!bulkStatus || !bulkSelectedOrders.length || bulkSubmitting) return;

    const forbiddenPendingOrders = bulkSelectedOrders.filter((order) => (
      order?.status === 'pending' && bulkStatus !== order.status && !canManagePendingPayments
    ));
    if (forbiddenPendingOrders.length) {
      toast.error("Seuls un manager ou un administrateur peuvent changer le statut d'une commande en attente de paiement.");
      return;
    }
    const forbiddenProductionOrders = bulkSelectedOrders.filter((order) => (
      !canSetProductionStatus(order, bulkStatus)
    ));
    if (forbiddenProductionOrders.length) {
      toast.error('Pour ce profil, la production peut uniquement être démarrée depuis le statut « En cours ».');
      return;
    }
    if (PRODUCTION_STATUSES.includes(bulkStatus) && !bulkStoreId) {
      toast.error('Sélectionnez un magasin.');
      return;
    }
    if (bulkStatus === 'delivery-inroute' && !bulkDriverId) {
      toast.error('Sélectionnez un livreur.');
      return;
    }

    setBulkSubmitting(true);
    setBulkProgress({ completed: 0, total: bulkSelectedOrders.length });
    const successfulIds = [];
    const failures = [];
    const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

    for (const order of bulkSelectedOrders) {
      try {
        if (PRODUCTION_STATUSES.includes(bulkStatus)) {
          await InternalOrderService.createFromWoo(order, bulkStoreId);
          await updateWooOrder(order.id, { status: bulkStatus });
        } else if (bulkStatus === 'delivery-inroute') {
          const { localOrder, orderCode } = await ensureBulkInternalOrder(order);
          const localId = localOrder._id || localOrder.id;
          try {
            await axios.patch(`${API_URL}/orders/${localId}/driver/${bulkDriverId}`, { status: 'ongoing' }, header());
          } catch (error) {
            console.warn(`Failed to patch driver for WooCommerce order ${order.id}`, error);
          }
          await axios.post(`${API_URL}/orders/woo/status/driver`, {
            orderId: localId,
            orderCode,
            status: bulkStatus,
            driver_id: bulkDriverId
          }, header());
        } else {
          await updateWooOrder(order.id, { status: bulkStatus });
        }
        successfulIds.push(String(order.id));
      } catch (error) {
        console.error(`Bulk WooCommerce update failed for order ${order?.id}`, error);
        failures.push({ order, error });
      } finally {
        setBulkProgress((previous) => ({ ...previous, completed: previous.completed + 1 }));
      }
    }

    try {
      await fetch();
    } finally {
      const successfulSet = new Set(successfulIds);
      setBulkSelectionModel((previous) => previous.filter((id) => !successfulSet.has(String(id))));
      setBulkSubmitting(false);
    }

    if (successfulIds.length) {
      toast.success(`${successfulIds.length} commande(s) mise(s) à jour.`);
    }
    if (failures.length) {
      toast.error(`${failures.length} commande(s) n'ont pas pu être mises à jour et restent sélectionnées.`);
    } else {
      closeBulkDialog();
    }
  };

  const openPreview = (src) => {
    if (!src) return;
    setPreviewImage(src);
    setPreviewOpen(true);
  };

  const closePreview = () => { setPreviewOpen(false); setPreviewImage(null); };

  const submitCreateOrder = async () => {
    const {
      first_name,
      last_name,
      address_1,
      state,
      city,
      note,
      phone,
      delivery_date,
    } = createOrderForm;

    if (!first_name.trim() || !last_name.trim()) {
      alert('Nom et prénom sont requis');
      return;
    }

    if (!address_1.trim()) {
      alert('Adresse est requise');
      return;
    }

    if (!city) {
      alert('Ville est requise');
      return;
    }

    if (!phone.trim()) {
      alert('Numéro de téléphone est requis');
      return;
    }

    const feeLines = createOrderFees
      .filter((fee) => String(fee.name || '').trim() && String(fee.total || '').trim())
      .map((fee) => ({
        name: String(fee.name).trim(),
        total: String(fee.total).trim(),
      }));

    if (!createOrderProducts.length && !feeLines.length) {
      alert('Ajoutez au moins un produit ou un frais');
      return;
    }

    setCreateOrderSubmitting(true);

    try {
      const formattedDeliveryDate = delivery_date ? formatDateToDDMMYYYY(delivery_date) : '';

      const payload = {
        status: 'pending',
        set_paid: false,
        billing: {
          first_name: first_name.trim(),
          last_name: last_name.trim(),
          address_1: address_1.trim(),
          city,
          state,
          country: 'MA',
          phone: phone.trim(),
        },
        shipping: {
          first_name: first_name.trim(),
          last_name: last_name.trim(),
          address_1: address_1.trim(),
          city,
          state,
          country: 'MA',
          phone: phone.trim(),
          shipping_phonenumber: phone.trim(),
        },
        customer_note: String(note || '').trim(),
        line_items: createOrderProducts.map((item) => {
          const quantity = Math.max(1, Number(item.quantity) || 1);
          const unitPrice = Math.max(0, Number(item.price) || 0);
          const lineTotal = (unitPrice * quantity).toFixed(2);

          return {
            product_id: Number(item.product_id),
            quantity,
            subtotal: lineTotal,
            total: lineTotal,
          };
        }),
        fee_lines: feeLines,
        meta_data: [
          ...(formattedDeliveryDate
            ? [
                { key: 'Date de Livraison', value: formattedDeliveryDate },
                { key: '_orddd_delivery_date', value: formattedDeliveryDate },
                { key: 'delivery_date_locale', value: formattedDeliveryDate },
              ]
            : []),
        ],
      };

      const createdOrder = await createWooCommerceOrder(payload);
      try {
        const refreshed = await getWooCommerceOrders({ statuses: fetchStatuses, per_page: perPage, page: 1 });
        const refreshedData = refreshed && refreshed.data ? refreshed.data : (Array.isArray(refreshed) ? refreshed : []);
        const normalizedRows = Array.isArray(refreshedData) ? refreshedData : [];
        const mergedRows = createdOrder?.id
          ? [
              createdOrder,
              ...normalizedRows.filter((order) => String(order?.id || '') !== String(createdOrder.id)),
            ]
          : normalizedRows;

        setOrders(mergedRows.slice(0, perPage));
        setTotal(refreshed && typeof refreshed.total === 'number'
          ? Math.max(refreshed.total, createdOrder?.id ? mergedRows.length : refreshed.total)
          : mergedRows.length);
        setPage(1);
      } catch (refreshError) {
        console.error('Failed to refresh WooCommerce orders after creation', refreshError);
        setOrders((prev) => {
          if (!createdOrder?.id) {
            return prev;
          }

          const next = [
            createdOrder,
            ...(Array.isArray(prev) ? prev.filter((order) => String(order?.id || '') !== String(createdOrder.id)) : []),
          ];

          return next.slice(0, perPage);
        });
        setTotal((prev) => Number(prev || 0) + (createdOrder?.id ? 1 : 0));
        setPage(1);
      }
      setCreateOrderDialogOpen(false);
      resetCreateOrderDialog();
      setCreatedOrderResult(createdOrder || null);
      if (createdOrder?.id) {
        toast.success(`Commande WooCommerce #${createdOrder.id} créée en attente de paiement`);
      } else {
        toast.success('Commande WooCommerce créée en attente de paiement');
      }
    } catch (error) {
      console.error('Failed to create WooCommerce order', error);
      alert('Erreur lors de la création de la commande WooCommerce');
    } finally {
      setCreateOrderSubmitting(false);
    }
  };

  const handleMarkAsReady = async (orderCode) => {
    try {
      const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
      await axios.post(
        `${API_URL}/endOrder`,
        { orderCode },
        header()
      );
      // Refresh orders after marking as ready
      await fetch();
    } catch (error) {
      console.error('Error marking order as ready:', error);
      alert('Failed to mark order as ready');
    }
  };

  const getDeliveryDate = (o) => {
    if (!o) return '—';
    // try known metadata keys
    const meta = Array.isArray(o.meta_data) ? o.meta_data : [];
    const keys = ['Date de Livraison', '_orddd_delivery_date', 'delivery_date_locale', 'delivery_date_formatted'];
    for (const k of keys) {
      const m = meta.find(x => x.key === k || (x.key && x.key.toLowerCase() === k.toLowerCase()));
      if (m && m.value) return m.value;
    }
    // fallback to date_paid or date_created
    return o.date_paid || o.date_created || '—';
  };

  const getOrderMetaValue = (o, keys = []) => {
    if (!o || !Array.isArray(o.meta_data)) return '';
    const normalizedKeys = keys.map((key) => String(key).toLowerCase());
    const found = o.meta_data.find((item) => normalizedKeys.includes(String(item?.key || '').toLowerCase()));
    return found?.value || '';
  };

  const getDeliveryTime = (o) => getOrderMetaValue(o, ['Heure de Livraison', 'delivery_time', '_pegasus_delivery_time']);

  const getDeliveryRegion = (o) => getOrderMetaValue(o, ['Region de Livraison', 'delivery_region', '_pegasus_delivery_region']);

  const getShippingFullName = (o) => {
    if (!o) return '—';
    const s = o.shipping || {};
    const first = s.first_name || '';
    const last = s.last_name || '';
    return (first || last) ? `${first} ${last}`.trim() : (s.shipping_phonenumber || s.phone || '—');
  };

  const getFullShippingAddress = (o) => {
    if (!o || !o.shipping) return '';
    const s = o.shipping;
    const parts = [
      s.address_1,
      s.address_2,
      s.city,
      s.state,
      s.postcode,
      s.country
    ].filter(Boolean);
    return parts.join(', ');
  };

  const getCustomerPreference = (o) => {
    if (!o) return null;

    const directValue = o.customer_preference ?? o.customerPreference;
    if (directValue !== undefined && directValue !== null && String(directValue).trim() !== '') {
      return directValue;
    }

    const meta = Array.isArray(o.meta_data) ? o.meta_data : [];
    const preferenceMeta = meta.find((item) => {
      const key = String(item?.key || '').toLowerCase();
      return key === 'customer_preference' || key === '_customer_preference' || key === 'customer preference';
    });

    return preferenceMeta?.value ?? null;
  };

  const getPrintImageUrl = (o) => getOrderMetaValue(o, [
    '_pegasus_print_image_url',
    'Image à imprimer',
    'Image a imprimer',
    'print_image_url',
    'customer_print_image'
  ]);

  const printerOptions = useMemo(() => (
    (remotePrinters || []).flatMap((remote) => (
      (remote.printers || []).map((printer) => ({
        ...printer,
        computer_name: remote.computer_name || remote.machine_uid,
        store_id: remote.store_id || '',
        remote_printer_id: remote._id
      }))
    ))
  ), [remotePrinters]);

  const selectedImagePrintPrinter = printerOptions.find((printer) => printer.printer_uid === imagePrintPrinterUid);

  const fetchRemotePrinters = async () => {
    const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
    const response = await axios.get(`${API_URL}/printing/admin/printers`, header());
    const printers = response.data?.printers || [];
    setRemotePrinters(printers);
    const flattened = printers.flatMap((remote) => (
      (remote.printers || []).map((printer) => ({
        ...printer,
        computer_name: remote.computer_name || remote.machine_uid,
        store_id: remote.store_id || '',
      }))
    ));
    const preferred = flattened.find((printer) => printer.is_default) || flattened[0];
    if (preferred?.printer_uid) {
      setImagePrintPrinterUid((current) => current || preferred.printer_uid);
    }
  };

  const openImagePrintDialog = async (order) => {
    setImagePrintOrder(order);
    setImagePrintDialogOpen(true);
    try {
      await fetchRemotePrinters();
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erreur lors du chargement des imprimantes.');
    }
  };

  const closeImagePrintDialog = () => {
    if (imagePrintSubmitting) return;
    setImagePrintDialogOpen(false);
    setImagePrintOrder(null);
    setImagePrintPaperName('');
  };

  const submitImagePrint = async () => {
    const imageUrl = getPrintImageUrl(imagePrintOrder);
    if (!imagePrintPrinterUid || !imageUrl) {
      toast.error('Selectionnez une imprimante et une image.');
      return;
    }

    const paper = (selectedImagePrintPrinter?.paper_sizes || []).find((item) => item.name === imagePrintPaperName);
    setImagePrintSubmitting(true);
    try {
      const API_URL = process.env.REACT_APP_PEGASUS_API_URL;
      await axios.post(`${API_URL}/printing/admin/queue/image`, {
        printer_uid: imagePrintPrinterUid,
        image_url: imageUrl,
        quantity: 1,
        paper_size: paper || (imagePrintPaperName ? { name: imagePrintPaperName } : undefined),
        title: `Woo #${imagePrintOrder?.number || imagePrintOrder?.id || ''}`,
        metadata: {
          source: 'woo_order_image',
          woo_order_id: imagePrintOrder?.id,
          order_number: imagePrintOrder?.number || imagePrintOrder?.id,
          created_from_front: true
        }
      }, header());
      toast.success('Image ajoutee a la printing queue.');
      closeImagePrintDialog();
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erreur lors de la creation du job image.');
    } finally {
      setImagePrintSubmitting(false);
    }
  };

  const formatCustomerPreference = (value) => {
    if (value === null || value === undefined) return '';
    if (Array.isArray(value)) {
      return value
        .map((entry) => formatCustomerPreference(entry))
        .filter(Boolean)
        .join('\n');
    }
    if (typeof value === 'object') {
      return Object.entries(value)
        .filter(([, entryValue]) => entryValue !== null && entryValue !== undefined && String(entryValue).trim() !== '')
        .map(([key, entryValue]) => `${key}: ${typeof entryValue === 'object' ? JSON.stringify(entryValue) : entryValue}`)
        .join('\n');
    }
    return String(value).trim();
  };

  const openGoogleMapsForAddress = (address) => {
    if (!address) return;
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  const exportOrdersToCSV = async () => {
    try {
      // Filter orders based on current filters and driver filter
      let filteredOrders = orders.filter(o => {
        if (!o) return false;
        
        // Apply search filter
        if (searchQuery) {
          const q = searchQuery.toLowerCase();
          if (!(String(o.id).includes(q) || (o.shipping && ((o.shipping.first_name || '') + ' ' + (o.shipping.last_name || '')).toLowerCase().includes(q) || (o.billing && (o.billing.email || '').toLowerCase().includes(q))))) return false;
        }
        
        // Apply status filter
        if (Array.isArray(statusFilter) && statusFilter.length > 0 && !statusFilter.includes(o.status)) return false;
        
        // Apply date filter
        if (dateFrom || dateTo) {
          const orderDate = o.date_created || o.date_created_gmt;
          if (orderDate) {
            const od = new Date(orderDate);
            if (dateFrom && od < new Date(dateFrom)) return false;
            if (dateTo && od > new Date(dateTo)) return false;
          }
        }
        
        // Apply driver filter
        if (driverFilter) {
          const internalOrder = internalOrdersDetailsMap[o.id] || internalOrdersMap[o.id];
          const driverId = normalizeId(internalOrder?.affected?.driver_id || internalOrder?.driver_id || '');
          if (driverId !== driverFilter) return false;
        }
        
        return true;
      });
      
      // Create workbook and worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Commandes');
      
      // Define columns
      worksheet.columns = [
        { header: 'Order ID', key: 'orderId', width: 12 },
        { header: 'Nom', key: 'nom', width: 20 },
        { header: 'Prénom', key: 'prenom', width: 20 },
        { header: 'Adresse', key: 'adresse', width: 40 },
        { header: 'Ville', key: 'ville', width: 20 },
        { header: 'Téléphone', key: 'telephone', width: 15 },
        { header: 'Date de Livraison', key: 'dateLivraison', width: 18 },
        { header: 'Nombre de Produits', key: 'nombreProduits', width: 18 },
        { header: 'Nombre de Frais', key: 'nombreFrais', width: 15 },
        { header: 'Total Articles', key: 'totalArticles', width: 15 },
        { header: 'Nom du Livreur', key: 'nomLivreur', width: 25 }
      ];
      
      // Style header row
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE0E0E0' }
      };
      
      // Add data rows
      filteredOrders.forEach(order => {
        const shipping = order?.shipping || {};
        const lineItems = Array.isArray(order?.line_items) ? order.line_items : [];
        const feeLines = Array.isArray(order?.fee_lines) ? order.fee_lines : [];
        const totalItems = lineItems.reduce((sum, item) => sum + (Number(item?.quantity) || 0), 0);
        
        // Get delivery date
        const deliveryDate = formatDateToDDMMYYYY(getDeliveryDate(order));
        
        // Get driver name
        const internalOrder = internalOrdersDetailsMap[order.id] || internalOrdersMap[order.id];
        const driverId = normalizeId(internalOrder?.affected?.driver_id || internalOrder?.driver_id || '');
        const driverName = driverId && usersMap[driverId] ? usersMap[driverId].userfullname : '';
        
        // Build full address
        const addressParts = [
          shipping?.address_1,
          shipping?.address_2
        ].filter(Boolean).join(', ');
        
        // Get phone number
        const phoneRaw = (shipping?.shipping_phonenumber || shipping?.phone || '').toString().trim();
        
        worksheet.addRow({
          orderId: order?.number || order?.id || '',
          nom: shipping?.last_name || '',
          prenom: shipping?.first_name || '',
          adresse: addressParts || '',
          ville: shipping?.city || '',
          telephone: phoneRaw,
          dateLivraison: deliveryDate,
          nombreProduits: lineItems.length || 0,
          nombreFrais: feeLines.length || 0,
          totalArticles: totalItems || 0,
          nomLivreur: driverName
        });
      });
      
      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      
      // Create and download file
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      const timestamp = new Date().toISOString().slice(0, 10);
      const driverSuffix = driverFilter ? `_driver_${driverFilter}` : '';
      link.setAttribute('href', url);
      link.setAttribute('download', `commandes_woo_${timestamp}${driverSuffix}.xlsx`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
    } catch (error) {
      console.error('Export error:', error);
      alert('Erreur lors de l\'exportation');
    }
  };

  const formatCurrency = (amount, order) => {
    if (amount === undefined || amount === null) return '—';
    const symbol = (order && (order.currency_symbol || order.currency)) || '';
    // ensure numeric
    const n = Number(amount);
    if (Number.isNaN(n)) return `${amount} ${symbol}`;
    return `${n.toFixed(2)} ${symbol}`.trim();
  };

  const computeOrderTotals = (o) => {
    const items = Array.isArray(o.line_items) ? o.line_items : [];
    const fees = Array.isArray(o.fee_lines) ? o.fee_lines : [];
    const subtotal = items.reduce((s, li) => s + (Number(li.total) || (Number(li.price) * (li.quantity || 1)) || 0), 0);
    const feesTotal = fees.reduce((s, f) => s + (Number(f.total) || Number(f.amount) || 0), 0);
    const shipping = Number(o.shipping_total) || (o.shipping_lines && o.shipping_lines[0] && Number(o.shipping_lines[0].total)) || 0;
    const total = Number(o.total) || subtotal + shipping + feesTotal;
    return { subtotal, feesTotal, shipping, total };
  };

  // Status counts for dashboard cards
  const processingCount = visibleOrders.filter(o => o && o.status === 'processing').length;
  const onHoldCount = visibleOrders.filter(o => o && o.status === 'on-hold').length;
  const deliveryInrouteCount = visibleOrders.filter(o => o && o.status === 'delivery-inroute').length;
  const productionCount = visibleOrders.filter(o => o && (o.status === 'en-cours-de-produ' || o.status === 'en-cours-prod-mp')).length;

  // Aggregate products by delivery date
  const aggregateProductsByDate = () => {
    const aggregated = {};
    
    visibleOrders.forEach(order => {
      const deliveryDate = getDeliveryDate(order);
      const dateKey = deliveryDate || 'No Date';
      
      if (!aggregated[dateKey]) {
        aggregated[dateKey] = {};
      }
      
      // Process line items (products)
      (order.line_items || []).forEach(item => {
        const productKey = item.name || 'Unknown Product';
        
        if (!aggregated[dateKey][productKey]) {
          aggregated[dateKey][productKey] = {
            name: productKey,
            type: 'product',
            quantity: 0,
            total: 0,
            sku: item.sku || '—',
            image: (item.image && item.image.src) || '',
            orders: [],
            options: []
          };
        }
        
        aggregated[dateKey][productKey].quantity += item.quantity || 0;
        aggregated[dateKey][productKey].total += Number(item.total) || 0;
        aggregated[dateKey][productKey].orders.push({
          orderNumber: order.number || order.id,
          customerName: getShippingFullName(order)
        });
        
        // Collect unique options
        if (Array.isArray(item.meta_data)) {
          item.meta_data.forEach(m => {
            if (!m || String(m.key || '').startsWith('_')) return;
            const optionLabel = `${m.display_key || m.key}: ${m.display_value || m.value}`;
            if (!aggregated[dateKey][productKey].options.includes(optionLabel)) {
              aggregated[dateKey][productKey].options.push(optionLabel);
            }
          });
        }
      });
      
      // Process fee lines
      (order.fee_lines || []).forEach(fee => {
        const feeKey = fee.name || 'Fee';
        
        if (!aggregated[dateKey][feeKey]) {
          aggregated[dateKey][feeKey] = {
            name: feeKey,
            type: 'fee',
            quantity: 0,
            total: 0,
            sku: '—',
            image: '',
            orders: [],
            options: []
          };
        }
        
        aggregated[dateKey][feeKey].quantity += 1;
        aggregated[dateKey][feeKey].total += Number(fee.total || fee.amount) || 0;
        aggregated[dateKey][feeKey].orders.push({
          orderNumber: order.number || order.id,
          customerName: getShippingFullName(order)
        });
      });
    });
    
    return aggregated;
  };

  const productsByDate = aggregateProductsByDate();
  const createOrderProductsTotal = createOrderProducts.reduce(
    (sum, item) => sum + (Number(item.price || 0) * Math.max(1, Number(item.quantity) || 1)),
    0
  );
  const createOrderFeesTotal = createOrderFees.reduce((sum, fee) => {
    const amount = Number(fee.total || 0);
    return sum + (Number.isFinite(amount) ? amount : 0);
  }, 0);

  const headerBg = selectedOrder ? hexToRgba(STATUS_COLORS[selectedOrder.status] || '#FFFFFF', 0.12) : '#FFFFFF';
  const headerBorder = selectedOrder ? `1px solid ${hexToRgba(STATUS_COLORS[selectedOrder.status] || '#E5E7EB', 0.2)}` : '1px solid #E5E7EB';

  return (
    <Container maxWidth={false} sx={{ p: 2, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ color: '#111827', m: 0 }}>Commandes WooCommerce</Typography>
          <Typography variant="caption" color="text.secondary">List of recent orders</Typography>
        </Box>

        <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap" useFlexGap>
          <TextField size="small" placeholder="Search orders" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} sx={{ bgcolor: 'white', minWidth: 140, width: 140 }} />
          <TextField
            select
            size="small"
            value={driverFilter}
            onChange={e => setDriverFilter(e.target.value)}
            sx={{ minWidth: 160, width: 160, bgcolor: 'white' }}
            SelectProps={{
              displayEmpty: true
            }}
          >
            <MenuItem value="">Tous les livreurs</MenuItem>
            {Object.values(usersMap).map(user => (
              <MenuItem key={user.user_id} value={user.user_id}>
                {user.userfullname || user.user_id}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            size="small"
            value={statusFilter}
            onChange={e => setStatusFilter(e.target.value)}
            sx={{ minWidth: 140, width: 140, bgcolor: 'white' }}
            SelectProps={{
              multiple: true,
              renderValue: (selected) => Array.isArray(selected) && selected.length > 0 ? `${selected.length} selected` : 'Status'
            }}
          >
            {Object.keys(STATUS_LABELS).filter((s) => canManagePendingPayments || s !== 'pending').map(s => (
              <MenuItem key={s} value={s}>
                <Checkbox checked={Array.isArray(statusFilter) ? statusFilter.indexOf(s) > -1 : false} />
                <ListItemText primary={STATUS_LABELS[s] || s} />
              </MenuItem>
            ))}
          </TextField>
          <TextField type="date" size="small" value={dateFrom} onChange={e => setDateFrom(e.target.value)} sx={{ bgcolor: 'white', width: 140 }} />
          <TextField type="date" size="small" value={dateTo} onChange={e => setDateTo(e.target.value)} sx={{ bgcolor: 'white', width: 140 }} />
          <TextField select size="small" value={perPage} onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }} sx={{ minWidth: 70, width: 70, bgcolor: 'white' }}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </TextField>
          <Tooltip title="Export orders">
            <IconButton size="small" onClick={exportOrdersToCSV} sx={{ bgcolor: 'white', border: '1px solid #E5E7EB', '&:hover': { bgcolor: '#F3F4F6' } }}>
              <FileDownloadIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Refresh orders">
            <IconButton size="small" onClick={() => fetch()} sx={{ bgcolor: 'white', border: '1px solid #E5E7EB', '&:hover': { bgcolor: '#F3F4F6' } }}>
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          {canManagePendingPayments && (
            <Button
              variant="contained"
              onClick={openCreateOrderDialog}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              Créer Commande
            </Button>
          )}
        </Stack>
      </Box>

      {/* Status summary cards */}
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: hexToRgba(STATUS_COLORS.processing, 0.12), borderColor: STATUS_COLORS.processing }}>
              <Typography variant="subtitle2" color="text.secondary">Processing</Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, color: STATUS_COLORS.processing }}>{processingCount}</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: hexToRgba(STATUS_COLORS['on-hold'], 0.12), borderColor: STATUS_COLORS['on-hold'] }}>
              <Typography variant="subtitle2" color="text.secondary">On-hold</Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, color: STATUS_COLORS['on-hold'] }}>{onHoldCount}</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: hexToRgba(STATUS_COLORS['delivery-inroute'], 0.12), borderColor: STATUS_COLORS['delivery-inroute'] }}>
              <Typography variant="subtitle2" color="text.secondary">Livraison en cours</Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, color: STATUS_COLORS['delivery-inroute'] }}>{deliveryInrouteCount}</Typography>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Card sx={{ p: 2, bgcolor: hexToRgba(STATUS_COLORS['en-cours-de-produ'] || STATUS_COLORS['en-cours-prod-mp'] || STATUS_COLORS.processing, 0.12), borderColor: STATUS_COLORS['en-cours-de-produ'] || STATUS_COLORS['en-cours-prod-mp'] || STATUS_COLORS.processing }}>
              <Typography variant="subtitle2" color="text.secondary">En cours production</Typography>
              <Typography variant="h5" sx={{ fontWeight: 700, color: STATUS_COLORS['en-cours-de-produ'] || STATUS_COLORS['en-cours-prod-mp'] || STATUS_COLORS.processing }}>{productionCount}</Typography>
            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Tabs for Orders and Products views */}
      <Box sx={{ mt: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} aria-label="order views">
          <Tab label={`Orders (${visibleOrders.length})`} />
          <Tab label="Products Summary by Date" />
        </Tabs>
      </Box>

      {/* Orders Tab */}
      {activeTab === 0 && (
        <Box sx={{ mt: 0, width: '100%' }}>
          {bulkSelectionModel.length > 0 && (
            <Paper
              variant="outlined"
              sx={{
                mb: 1,
                px: 2,
                py: 1.25,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                flexWrap: 'wrap',
                borderColor: '#BFDBFE',
                bgcolor: '#EFF6FF'
              }}
            >
              <Box>
                <Typography sx={{ fontWeight: 700, color: '#1E3A8A' }}>
                  {bulkSelectedOrders.length} commande(s) sélectionnée(s)
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Les mêmes règles de statut, magasin et livreur seront appliquées à chaque commande.
                </Typography>
              </Box>
              <Stack direction="row" spacing={1}>
                <Button
                  size="small"
                  onClick={() => setBulkSelectionModel([])}
                  disabled={bulkSubmitting}
                >
                  Désélectionner
                </Button>
                <Button
                  size="small"
                  variant="contained"
                  onClick={openBulkDialog}
                  disabled={!bulkSelectedOrders.length || bulkSubmitting}
                >
                  Modifier la sélection
                </Button>
              </Stack>
            </Paper>
          )}
          <Box sx={{ height: '65vh', width: '100%', display: 'flex', bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 2px rgba(15,23,42,0.04)', border: '1px solid #E5E7EB' }}>
          <DataGrid
          density="compact"
          rowHeight={64}
          headerHeight={56}
          rows={visibleOrders.filter(o => {
            // basic search
            if (searchQuery) {
              const q = searchQuery.toLowerCase();
              if (!(String(o.id).includes(q) || (o.shipping && ((o.shipping.first_name || '') + ' ' + (o.shipping.last_name || '')).toLowerCase().includes(q) || (o.billing && (o.billing.email || '').toLowerCase().includes(q))))) return false;
            }
            if (Array.isArray(statusFilter) && statusFilter.length > 0) {
              if (!statusFilter.includes(o.status)) return false;
            }
            if (dateFrom) {
              const from = new Date(dateFrom);
              const del = parseDeliveryToDate(getDeliveryDate(o));
              if (!del || del < from) return false;
            }
            if (dateTo) {
              const to = new Date(dateTo);
              const del = parseDeliveryToDate(getDeliveryDate(o));
              if (!del || del > to) return false;
            }
            // Driver filter
            if (driverFilter) {
              const internalOrder = internalOrdersDetailsMap[o.id] || internalOrdersMap[o.id];
              const driverId = normalizeId(internalOrder?.affected?.driver_id || internalOrder?.driver_id || '');
              if (driverId !== driverFilter) return false;
            }
            return true;
          }).map(o => ({ id: o.id, order: o }))}
          columns={[
            { field: 'id', headerName: 'Order ID', width: 120, renderCell: (params) => {
              const inDb = internalOrdersMap && internalOrdersMap[params.row.order.id];
              return (
                <Button
                  size="small"
                  onClick={() => openOrderDialog(params.row.order)}
                  startIcon={<VisibilityIcon />}
                  variant={inDb ? 'contained' : 'text'}
                  sx={inDb ? { bgcolor: '#ECFDF5', color: '#059669' } : {}}
                >{params.value}</Button>
              );
            }},
            { field: 'status', headerName: 'WooCommerce Status', width: 170, sortable: false, renderCell: (params) => {
              const o = params.row.order;
              const s = (o && o.status) || '';
              const color = STATUS_COLORS[s] || '#9CA3AF';
              return <Chip label={STATUS_LABELS[s] || s || '—'} size="small" sx={{ bgcolor: color, color: '#fff', fontWeight: 600, px: 1 }} />;
            }},
            { field: 'localStatus', headerName: 'Local Status', width: 140, sortable: false, renderCell: (params) => {
              const localOrder = internalOrdersMap && internalOrdersMap[params.row.order.id];
              if (!localOrder || !localOrder.orderStatus) return <Typography variant="caption" color="text.secondary">—</Typography>;
              const statusColors = {
                accepted: '#F59E0B',
                ready: '#3B82F6',
                completed: '#10B981',
                gone: '#6B7280'
              };
              const color = statusColors[localOrder.orderStatus] || '#9CA3AF';
              return <Chip label={localOrder.orderStatus} size="small" sx={{ bgcolor: color, color: '#fff', fontWeight: 600, px: 1, textTransform: 'capitalize' }} />;
            }},
            { field: 'markReady', headerName: 'Mark Ready', width: 120, sortable: false, renderCell: (params) => {
              const localOrder = internalOrdersMap && internalOrdersMap[params.row.order.id];
              const isAccepted = localOrder && localOrder.orderStatus === 'accepted';
              if (!isAccepted) return null;
              return (
                <Tooltip title="Mark as Ready">
                  <IconButton 
                    size="small" 
                    onClick={() => handleMarkAsReady(String(params.row.order.id))}
                    sx={{ color: '#10B981', '&:hover': { bgcolor: '#ECFDF5' } }}
                  >
                    <CheckCircleIcon />
                  </IconButton>
                </Tooltip>
              );
            }},
            { field: 'delivery', headerName: 'Delivery Date', width: 160, 
              valueGetter: (params) => {
                const o = params.row.order;
                const raw = getDeliveryDate(o);
                return raw;
              },
              sortComparator: (v1, v2) => {
                const d1 = parseDeliveryToDate(v1);
                const d2 = parseDeliveryToDate(v2);
                if (!d1 && !d2) return 0;
                if (!d1) return 1;
                if (!d2) return -1;
                return d1.getTime() - d2.getTime();
              },
              renderCell: (params) => {
              const o = params.row.order;
              const raw = getDeliveryDate(o);
              const formatted = formatDateToDDMMYYYY(raw);
              const ind = deliveryIndicator(raw);
              return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><CalendarTodayIcon fontSize="small" sx={{ color: '#6B7280' }} /><Box><Typography>{formatted}</Typography><Typography variant="caption" color="text.secondary">{ind}</Typography></Box></Box>;
            }},
            { field: 'customer', headerName: 'Customer', flex: 1, minWidth: 180, renderCell: (params) => {
              const o = params.row.order;
              const name = getShippingFullName(o) || (o.billing && (o.billing.email || '—'));
              return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                  <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{name}</Typography>
                  {o && o.customer_note && (
                    <Tooltip title="Has customer note">
                      <NoteIcon fontSize="small" sx={{ color: '#F59E0B' }} />
                    </Tooltip>
                  )}
                </Box>
              );
            }},
            { field: 'items', headerName: 'Items', width: 90, renderCell: (params) => {
              const o = params.row.order;
              const c = (o.line_items || []).length;
              return <Chip label={c} size="small" sx={{ bgcolor: '#F3F4F6' }} />;
            }},
            { field: 'driver', headerName: 'Livreur', width: 200, renderCell: (params) => {
              const o = params.row.order || {};
              const code = String(o.id || '');
              const local = internalOrdersDetailsMap && internalOrdersDetailsMap[code];
              // prefer driver info from the local internal order when available
              let raw = local ? (local.affected?.driver_id || local.driver_id || local.driver || null) : null;
              if (!raw) raw = o.affected?.driver_id || o.driver_id || null;
              let display = '—';
              if (raw) {
                if (typeof raw === 'object') {
                  const candidate = raw._id || raw.$oid || raw.id || raw.value || raw || null;
                  const key = candidate ? normalizeId(String(candidate)) : null;
                  if (key && usersMap[key]) display = usersMap[key].userfullname || usersMap[key].user_id || key;
                  else display = [raw?.name, raw?.lastname].filter(Boolean).join(' ') || raw?.email || raw?.username || (key || '—');
                } else {
                  const key = String(raw);
                  display = (usersMap[key] && (usersMap[key].userfullname || usersMap[key].user_id)) || key;
                }
              }
              return <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{display}</Typography>;
            }},
            { field: 'amount', headerName: 'Total', width: 120, align: 'right', headerAlign: 'right', renderCell: (params) => {
              const o = params.row.order;
              return <Typography sx={{ fontWeight: 700 }}>{formatCurrency(o.total, o)}</Typography>;
            }},
            { field: 'payment', headerName: 'Payment', flex: 1, minWidth: 140, renderCell: (params) => {
              const o = params.row.order;
              return <Typography variant="body2">{o.payment_method_title || o.payment_method || '—'}</Typography>;
            }},
            { field: 'actions', headerName: 'Actions', width: 220, sortable: false, renderCell: (params) => {
              const o = params.row.order;
              const exists = internalOrdersMap && internalOrdersMap[o.id];
              const code = String(o.id);
              const handlePrintDb = async () => {
                try {
                  const res = await InternalOrderService.getOrderByCode(code);
                  if (res) {
                    // Prepare receipt data with billing details from WooCommerce order
                    const billing = o.billing || {};
                    const shipping = o.shipping || {};
                    const receiptData = {
                      ...res,
                      // Add billing details
                      billing: {
                        first_name: billing.first_name || '',
                        last_name: billing.last_name || '',
                        address_1: billing.address_1 || '',
                        address_2: billing.address_2 || '',
                        city: billing.city || '',
                        state: getStateName(billing.state) || billing.state || '',
                        postcode: billing.postcode || '',
                        phone: billing.phone || '',
                        email: billing.email || ''
                      },
                      shipping: {
                        first_name: shipping.first_name || '',
                        last_name: shipping.last_name || '',
                        address_1: shipping.address_1 || '',
                        address_2: shipping.address_2 || '',
                        city: shipping.city || '',
                        state: getStateName(shipping.state) || shipping.state || '',
                        postcode: shipping.postcode || ''
                      },
                      // Truncate customer note to 50 characters
                      customer_note: o.customer_note ? (o.customer_note.length > 50 ? o.customer_note.substring(0, 50) + '...' : o.customer_note) : '',
                      // Flag to hide prices in receipt
                      hidePrices: true,
                      // Keep original WooCommerce order number
                      orderNumber: o.number || o.id || res.orderNumber
                    };
                    localStorage.setItem('order', JSON.stringify(receiptData));
                    window.open('/print-receipt', '_blank');
                  }
                } catch (e) { console.error('getOrderByCode', e); alert('Failed to load local order for printing'); }
              };
              const handleAddOrder = async () => {
                try {
                  const created = await InternalOrderService.createFromWoo(o, null);
                  if (created && created.order) {
                    setInternalOrdersMap(prev => ({ ...(prev||{}), [o.id]: created.order }));
                    localStorage.setItem('order', JSON.stringify(created));
                    window.open('/print-receipt', '_blank');
                  }
                } catch (e) { console.error('createFromWoo', e); alert('Failed to create order in local service'); }
              };

              return <Stack direction="row" spacing={1}>
                <Tooltip title="View"><IconButton size="small" onClick={() => openOrderDialog(o)}><VisibilityIcon /></IconButton></Tooltip>
                {canManagePendingPayments && o && o.status === 'pending' && o.payment_url && (
                  <>
                    <Tooltip title="Open payment"><IconButton size="small" onClick={() => window.open(o.payment_url, '_blank')}><OpenInNewIcon /></IconButton></Tooltip>
                    <Tooltip title="Copy payment link"><IconButton size="small" onClick={() => copyPaymentLink(o.payment_url)}><ContentCopyIcon /></IconButton></Tooltip>
                  </>
                )}
                {exists && <Tooltip title="Print (Local)"><IconButton size="small" onClick={handlePrintDb}><PrintIcon /></IconButton></Tooltip>}
              </Stack>;
            }},
          ]}
          pageSize={perPage}
          checkboxSelection
          rowSelectionModel={bulkSelectionModel}
          onRowSelectionModelChange={(selection) => setBulkSelectionModel(selection)}
          disableRowSelectionOnClick
          onCellDoubleClick={(params, event) => {
            if (params && params.field === 'status' && params.row && params.row.order) {
              setSelectedOrder(params.row.order);
              setNewStatus((params.row.order && params.row.order.status) || '');
              setStatusDialogOpen(true);
            }
          }}
          onRowDoubleClick={async (params, event) => {
            try {
              const o = params && params.row && params.row.order;
              if (!o) return;
              const exists = internalOrdersMap && internalOrdersMap[o.id];
              if (exists) return; // already exists
              const created = await InternalOrderService.createFromWoo(o, null);
              if (created && created.order) {
                setInternalOrdersMap(prev => ({ ...(prev||{}), [o.id]: created.order }));
              }
            } catch (e) {
              console.error('row double-click create', e);
              alert('Failed to create order in local service');
            }
          }}
          rowsPerPageOptions={[10,25,50,100]}
          pagination
          disableSelectionOnClick
          initialState={{
            sorting: {
              sortModel: [{ field: 'delivery', sort: 'asc' }],
            },
          }}
          getRowClassName={(params) => (internalOrdersMap && internalOrdersMap[params.row.order.id]) ? 'in-db' : ''}
          sx={{
            flex: 1,
            minWidth: 0,
            border: 'none',
            '& .MuiDataGrid-root': { width: '100%' },
            '& .MuiDataGrid-row:hover': { backgroundColor: '#F3F4F6' },
            '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
            '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#FAFBFC' },
            '& .in-db': { backgroundColor: hexToRgba(STATUS_COLORS.completed || '#10B981', 0.06) },
            '& .MuiDataGrid-columnHeaders': { backgroundColor: '#fff', borderBottom: '1px solid #E5E7EB' },
            '& .MuiDataGrid-cell': { borderBottom: '1px solid #F3F4F6', color: '#111827' },
            '& .MuiDataGrid-virtualScroller': { overflowX: 'auto', minWidth: '100%' },
            '& .MuiDataGrid-main': { minWidth: '100%' }
          }}
        />
        </Box>
      </Box>
      )}

      {/* Products Summary Tab */}
      {activeTab === 1 && (
        <Box sx={{ mt: 2, bgcolor: '#fff', borderRadius: 2, boxShadow: '0 1px 2px rgba(15,23,42,0.04)', border: '1px solid #E5E7EB', p: 2, maxHeight: '70vh', overflowY: 'auto' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6">Products Summary by Delivery Date</Typography>
            <TextField
              size="small"
              placeholder="Search products..."
              value={productSearchQuery}
              onChange={(e) => setProductSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
              }}
              sx={{ minWidth: 250 }}
            />
          </Box>
          
          {Object.keys(productsByDate).sort((a, b) => {
            // Sort dates, with "No Date" at the end
            if (a === 'No Date') return 1;
            if (b === 'No Date') return -1;
            const dateA = parseDeliveryToDate(a);
            const dateB = parseDeliveryToDate(b);
            if (!dateA) return 1;
            if (!dateB) return -1;
            return dateA - dateB;
          }).map(dateKey => {
            const products = productsByDate[dateKey];
            // Filter and sort products by quantity (descending)
            const productList = Object.values(products)
              .filter(p => {
                if (!productSearchQuery) return true;
                const query = productSearchQuery.toLowerCase();
                return p.name.toLowerCase().includes(query) || 
                       (p.sku && p.sku.toLowerCase().includes(query)) ||
                       p.options.some(opt => opt.toLowerCase().includes(query));
              })
              .sort((a, b) => b.quantity - a.quantity);
            const totalProducts = productList.reduce((sum, p) => sum + p.quantity, 0);
            
            // Skip rendering date section if no products match search
            if (productList.length === 0) return null;
            
            return (
              <Box key={dateKey} sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, p: 2, bgcolor: '#F3F4F6', borderRadius: 1 }}>
                  <Typography variant="h6" sx={{ color: '#1F2937', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CalendarTodayIcon fontSize="small" />
                    {dateKey}
                  </Typography>
                  <Chip label={`${totalProducts} items total`} color="primary" />
                </Box>
                
                <Grid container spacing={2}>
                  {productList.map((product, idx) => (
                    <Grid item xs={6} sm={4} md={3} lg={2} key={`${dateKey}-${product.name}-${idx}`}>
                      <Card 
                        variant="outlined" 
                        sx={{ 
                          height: '100%', 
                          display: 'flex', 
                          flexDirection: 'column',
                          transition: 'all 0.3s ease',
                          '&:hover': { 
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            transform: 'translateY(-2px)'
                          }
                        }}
                      >
                        {/* Product Image */}
                        {product.image && (
                          <Box 
                            sx={{ 
                              width: '100%', 
                              paddingTop: '100%',
                              position: 'relative',
                              bgcolor: '#F9FAFB',
                              cursor: 'pointer',
                              overflow: 'hidden'
                            }}
                            onClick={() => openPreview(product.image)}
                          >
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: 1
                              }}
                            >
                              <img 
                                src={product.image} 
                                alt={product.name}
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '100%', 
                                  objectFit: 'contain',
                                  display: 'block'
                                }}
                              />
                            </Box>
                            {/* Quantity Badge on Image */}
                            <Box 
                              sx={{ 
                                position: 'absolute', 
                                top: 8, 
                                right: 8, 
                                bgcolor: '#059669', 
                                color: 'white',
                                borderRadius: '50%',
                                width: 56,
                                height: 56,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                              }}
                            >
                              <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1 }}>
                                {product.quantity}
                              </Typography>
                              <Typography variant="caption" sx={{ fontSize: '0.65rem', lineHeight: 1 }}>
                                items
                              </Typography>
                            </Box>
                          </Box>
                        )}
                        
                        <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 1, p: 2 }}>
                          {/* Product Name and Type */}
                          <Box>
                            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem', mb: 0.5, lineHeight: 1.3 }}>
                              {product.name}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', mb: 1 }}>
                              <Chip 
                                label={product.type === 'fee' ? 'Fee' : 'Product'} 
                                size="small"
                                color={product.type === 'fee' ? 'warning' : 'default'}
                                sx={{ height: 20 }}
                              />
                              <Typography variant="caption" color="text.secondary">
                                SKU: {product.sku}
                              </Typography>
                            </Box>
                          </Box>
                          
                          {/* Options */}
                          {product.options.length > 0 && (
                            <Box>
                              <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
                                Options:
                              </Typography>
                              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                {product.options.map((opt, optIdx) => (
                                  <Chip 
                                    key={optIdx} 
                                    label={opt} 
                                    size="small" 
                                    variant="outlined"
                                    color="warning"
                                    sx={{ height: 22, fontSize: '0.7rem' }}
                                  />
                                ))}
                              </Box>
                            </Box>
                          )}
                          
                          {/* Total Amount */}
                          <Box sx={{ mt: 'auto', pt: 1, borderTop: '1px solid #E5E7EB' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                              <Typography variant="caption" color="text.secondary">
                                Total Amount:
                              </Typography>
                              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1F2937' }}>
                                {product.total.toFixed(2)} MAD
                              </Typography>
                            </Box>
                            
                            {/* Orders Info */}
                            <Box sx={{ bgcolor: '#F9FAFB', p: 1, borderRadius: 1 }}>
                              <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
                                {product.orders.length} Order{product.orders.length > 1 ? 's' : ''}:
                              </Typography>
                              {product.orders.slice(0, 2).map((order, orderIdx) => (
                                <Typography key={orderIdx} variant="caption" sx={{ display: 'block', color: 'text.secondary', fontSize: '0.7rem' }}>
                                  #{order.orderNumber} - {order.customerName}
                                </Typography>
                              ))}
                              {product.orders.length > 2 && (
                                <Typography variant="caption" sx={{ color: 'primary.main', fontStyle: 'italic', fontSize: '0.7rem' }}>
                                  +{product.orders.length - 2} more...
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            );
          })}
          
          {Object.keys(productsByDate).length === 0 && (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography color="text.secondary">No products to display</Typography>
            </Box>
          )}
          {Object.keys(productsByDate).length > 0 && productSearchQuery && 
           Object.keys(productsByDate).every(dateKey => {
             const products = productsByDate[dateKey];
             return Object.values(products).filter(p => {
               const query = productSearchQuery.toLowerCase();
               return p.name.toLowerCase().includes(query) || 
                      (p.sku && p.sku.toLowerCase().includes(query)) ||
                      p.options.some(opt => opt.toLowerCase().includes(query));
             }).length === 0;
           }) && (
            <Box sx={{ p: 4, textAlign: 'center' }}>
              <Typography color="text.secondary">No products match your search "{productSearchQuery}"</Typography>
            </Box>
          )}
        </Box>
      )}

      <Dialog
        open={dialogOpen}
        onClose={closeOrderDialog}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: { xs: '100%', md: 780 },
            maxWidth: '100%',
            position: 'fixed',
            right: 16,
            top: 64,
            bottom: 16,
            m: 0,
            borderRadius: 2,
            overflow: 'hidden',
            bgcolor: '#FFFFFF'
          }
        }}
        aria-labelledby="order-details-title"
      >
        {/* Sticky Header */}
        <Box sx={{ position: 'sticky', top: 0, zIndex: 20, bgcolor: headerBg, borderBottom: headerBorder, p: 2, display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between' }}>
          <Box>
            <Typography id="order-details-title" variant="h6" sx={{ color: '#1F2937' }}>{selectedOrder ? `Order #${selectedOrder.number || selectedOrder.id}` : 'Order details'}</Typography>
            <Stack direction="row" spacing={1} sx={{ mt: 1, alignItems: 'center' }}>
              {/* Status chips */}
              {selectedOrder && (
                <>
                  <Chip label={STATUS_LABELS[selectedOrder.status] || selectedOrder.status} sx={{ backgroundColor: selectedOrder.status === 'processing' ? '#F59E0B' : (selectedOrder.status === 'delivery-inroute' ? '#3B82F6' : (selectedOrder.status === 'completed' ? '#10B981' : (selectedOrder.status === 'cancelled' ? '#EF4444' : '#9CA3AF'))), color: '#fff', fontWeight: 600 }} size="small" />
                  {selectedOrder.meta_data && selectedOrder.meta_data.find(m => m.key === '_orddd_delivery_date') && <Chip label={`Delivery: ${formatDateToDDMMYYYY(getDeliveryDate(selectedOrder))}`} icon={<LocalShippingIcon />} size="small" />}
                  <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>{selectedOrder ? `Created: ${formatDateToDDMMYYYY(selectedOrder.date_created || selectedOrder.date_created_gmt)}` : ''}</Typography>
                  {selectedDriverName ? (
                    <Chip label={`Livreur: ${selectedDriverName}`} size="small" sx={{ ml: 1, backgroundColor: '#E6F4FF', color: '#034C87', fontWeight: 600 }} />
                  ) : null}
                </>
              )}
            </Stack>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Tooltip title="Copy Order ID">
              <IconButton aria-label="copy-id" onClick={() => { if (selectedOrder) navigator.clipboard?.writeText(String(selectedOrder.id)); }}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            {canManagePendingPayments && selectedOrder && selectedOrder.status === 'pending' && selectedOrder.payment_url && (
              <>
                <Tooltip title="Open Payment Link">
                  <IconButton aria-label="open-payment" onClick={() => window.open(selectedOrder.payment_url, '_blank')}>
                    <OpenInNewIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Copy Payment Link">
                  <IconButton aria-label="copy-payment-link" onClick={() => copyPaymentLink(selectedOrder.payment_url)}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <Tooltip title="Print">
              <IconButton aria-label="print" onClick={() => printOrder(selectedOrder)}>
                <PrintIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={selectedOrder?.status === 'pending' && !canManagePendingPayments ? "Seuls un manager ou un administrateur peuvent changer ce statut" : "Update Status"}>
              <span>
                <IconButton
                  aria-label="update-status"
                  onClick={openStatusDialog}
                  disabled={selectedOrder?.status === 'pending' && !canManagePendingPayments}
                >
                  <Typography component="span">⚙︎</Typography>
                </IconButton>
              </span>
            </Tooltip>
            <IconButton aria-label="close" onClick={closeOrderDialog}><Typography component="span" aria-hidden>✕</Typography></IconButton>
          </Box>
        </Box>

        <DialogContent sx={{ p: 2, bgcolor: '#F7F8FA', height: '100%', overflowY: 'auto' }}>
          {selectedOrder && (
            <Grid container spacing={2}>
              {/* Billing and Shipping share a row (1/2 each) */}
              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ bgcolor: '#F0FDF4', borderColor: '#D1FAE5' }}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{ color: '#065F46' }}><strong>Billing</strong></Typography>
                    <Divider sx={{ my: 1, borderColor: '#D1FAE5' }} />
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                      <EmailIcon sx={{ color: '#065F46' }} />
                      <Typography>{selectedOrder.billing?.email || '—'}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 1 }}>
                      <PhoneIcon sx={{ color: '#065F46' }} />
                      <Typography>{selectedOrder.billing?.phone || '—'}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                      {((selectedOrder.billing && (selectedOrder.billing.phone)) || '').length > 0 && (
                        <Button size="small" variant="contained" startIcon={<PhoneIcon />} href={`tel:${selectedOrder.billing.phone}`} sx={{ bgcolor: '#059669', color: '#fff', '&:hover': { bgcolor: '#047857' } }}>Call</Button>
                      )}
                      {((selectedOrder.billing && (selectedOrder.billing.phone)) || '').length > 0 && (
                        <Button size="small" variant="contained" startIcon={<WhatsAppIcon />} href={`https://wa.me/${((selectedOrder.billing && selectedOrder.billing.phone) || '').replace(/\D/g, '')}`} target="_blank" rel="noreferrer" sx={{ bgcolor: '#10B981', color: '#fff', '&:hover': { bgcolor: '#059669' } }}>WhatsApp</Button>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} sm={6}>
                <Card variant="outlined" sx={{ bgcolor: '#EFF6FF', borderColor: '#DBEAFE' }}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{ color: '#1E3A8A' }}><strong>Shipping</strong></Typography>
                    <Divider sx={{ my: 1, borderColor: '#DBEAFE' }} />
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        gap: 1, 
                        alignItems: 'center',
                        cursor: getFullShippingAddress(selectedOrder) ? 'pointer' : 'default',
                        p: 1,
                        borderRadius: 1,
                        transition: 'background-color 0.2s',
                        '&:hover': getFullShippingAddress(selectedOrder) ? {
                          bgcolor: 'rgba(30, 58, 138, 0.08)'
                        } : {}
                      }}
                      onClick={() => {
                        const fullAddress = getFullShippingAddress(selectedOrder);
                        if (fullAddress) openGoogleMapsForAddress(fullAddress);
                      }}
                      title={getFullShippingAddress(selectedOrder) ? 'Click to open in Google Maps' : ''}
                    >
                      <LocationOnIcon sx={{ color: '#1E3A8A' }} />
                      <Box>
                        <Typography>{getShippingFullName(selectedOrder)}</Typography>
                        <Typography variant="body2">{selectedOrder.shipping?.address_1 || ''} {selectedOrder.shipping?.address_2 || ''}</Typography>
                        <Typography variant="body2">{[selectedOrder.shipping?.city, selectedOrder.shipping?.state].filter(Boolean).join(', ')}</Typography>
                        <Typography variant="body2">{selectedOrder.shipping?.shipping_phonenumber || selectedOrder.shipping?.phone || '—'}</Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                      {(((selectedOrder.shipping && (selectedOrder.shipping.shipping_phonenumber || selectedOrder.shipping.phone)) || '')).length > 0 && (
                        <Button size="small" variant="contained" startIcon={<PhoneIcon />} href={`tel:${selectedOrder.shipping?.shipping_phonenumber || selectedOrder.shipping?.phone}`} sx={{ bgcolor: '#1E40AF', color: '#fff', '&:hover': { bgcolor: '#1E3A8A' } }}>Call</Button>
                      )}
                      {(((selectedOrder.shipping && (selectedOrder.shipping.shipping_phonenumber || selectedOrder.shipping.phone)) || '')).length > 0 && (
                        <Button size="small" variant="contained" startIcon={<WhatsAppIcon />} href={`https://wa.me/${((selectedOrder.shipping && (selectedOrder.shipping.shipping_phonenumber || selectedOrder.shipping.phone)) || '').replace(/\D/g, '')}`} target="_blank" rel="noreferrer" sx={{ bgcolor: '#2563EB', color: '#fff', '&:hover': { bgcolor: '#1D4ED8' } }}>WhatsApp</Button>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Shipping method card and delivery badge (full width) */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ bgcolor: 'white', borderColor: '#E5E7EB' }}>
                  <CardContent sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'stretch', md: 'center' }, gap: 2 }}>
                    <Box>
                      <Typography variant="subtitle2"><LocalShippingIcon sx={{ mr: 1, verticalAlign: 'middle' }} />{(selectedOrder.shipping_lines && selectedOrder.shipping_lines[0] && selectedOrder.shipping_lines[0].method_title) || 'Shipping'}</Typography>
                      <Typography variant="body2" color="text.secondary">Shipping total: {formatCurrency(selectedOrder.shipping_total || (selectedOrder.shipping_lines && selectedOrder.shipping_lines[0] && selectedOrder.shipping_lines[0].total), selectedOrder)}</Typography>
                    </Box>
                    <Stack spacing={1} sx={{ alignItems: { xs: 'stretch', md: 'flex-end' } }}>
                      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
                        <Chip label={getDeliveryDate(selectedOrder)} sx={{ bgcolor: '#EEF2FF' }} />
                        {getDeliveryTime(selectedOrder) ? <Chip label={getDeliveryTime(selectedOrder)} sx={{ bgcolor: '#ECFDF5' }} /> : null}
                        {getDeliveryRegion(selectedOrder) ? <Chip label={getDeliveryRegion(selectedOrder)} sx={{ bgcolor: '#FFF7ED' }} /> : null}
                      </Stack>
                      {canChangeWooDeliveryDate && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
                          <TextField
                            type="date"
                            size="small"
                            label="Date de livraison"
                            value={deliveryDateDraft}
                            onChange={(event) => setDeliveryDateDraft(event.target.value)}
                            InputLabelProps={{ shrink: true }}
                          />
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<CalendarTodayIcon />}
                            onClick={handleUpdateDeliveryDate}
                            disabled={deliveryDateSaving || !deliveryDateDraft}
                          >
                            {deliveryDateSaving ? 'Enregistrement...' : 'Modifier'}
                          </Button>
                        </Stack>
                      )}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>

              {(() => {
                const customerPreference = formatCustomerPreference(getCustomerPreference(selectedOrder));
                if (!customerPreference) return null;

                return (
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ bgcolor: '#FEF2F2', borderColor: '#FCA5A5' }}>
                      <CardContent sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                        <NoteIcon sx={{ color: '#B91C1C', mt: 0.25 }} />
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="body2" sx={{ color: '#991B1B', fontWeight: 800, mb: 0.5 }}>
                            Demande Client
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#7F1D1D', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                            {customerPreference}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })()}

              {(() => {
                const printImageUrl = getPrintImageUrl(selectedOrder);
                if (!printImageUrl) return null;

                return (
                  <Grid item xs={12}>
                    <Card variant="outlined" sx={{ bgcolor: '#F8FAFC', borderColor: '#CBD5E1' }}>
                      <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                        <Avatar
                          variant="rounded"
                          src={printImageUrl}
                          sx={{ width: 96, height: 96, bgcolor: '#E2E8F0', cursor: 'pointer' }}
                          onClick={() => openPreview(printImageUrl)}
                        >
                          <ImageIcon />
                        </Avatar>
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 900, mb: 0.5 }}>
                            Image client à imprimer
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#64748B', wordBreak: 'break-all' }}>
                            {printImageUrl}
                          </Typography>
                          <Stack direction="row" spacing={1} sx={{ mt: 1 }} flexWrap="wrap">
                            <Button size="small" variant="outlined" startIcon={<OpenInNewIcon />} onClick={() => window.open(printImageUrl, '_blank', 'noreferrer')}>
                              Ouvrir
                            </Button>
                            <Button size="small" variant="contained" startIcon={<PrintIcon />} onClick={() => openImagePrintDialog(selectedOrder)}>
                              Imprimer via queue
                            </Button>
                          </Stack>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })()}

              {/* Customer note (full width) */}
              {selectedOrder.customer_note && (
                <Grid item xs={12}>
                  <Box sx={{ bgcolor: '#FEF3C7', p: 2, borderRadius: 1, border: '1px solid #FDE68A', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box sx={{ pr: 2, flex: 1, minWidth: 0 }}>
                      <Typography variant="body2" sx={{ mb: 0.5 }}><strong>Customer note</strong></Typography>
                      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{selectedOrder.customer_note}</Typography>
                    </Box>
                    <Box sx={{ flex: '0 0 auto', ml: 2 }}>
                      <Button
                        size="small"
                        variant="contained"
                        startIcon={<PrintIcon />}
                        onClick={() => {
                          try {
                            const orderId = selectedOrder.number || selectedOrder.id || '';
                            // store only the customer note HTML; the print page will render order number and square
                            const html = `<div style="font-family: Arial, Helvetica, sans-serif;">${selectedOrder.customer_note}</div>`;
                            // store HTML in sessionStorage and navigate to print page in the same tab (no query params)
                            try { sessionStorage.setItem('glovoNoteHtml', html); sessionStorage.setItem('glovoNoteOrder', orderId); } catch (e) {}
                            window.location.assign('/glovo-note-print');
                          } catch (e) { console.error('print customer note', e); }
                        }}
                      >
                        Print Note
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              )}

              {/* Items list (full width) */}
              <Grid item xs={12}>
                <Box>
                  <Typography variant="h6">Items</Typography>
                  <Divider sx={{ my: 1 }} />
                  <List>
                    {(selectedOrder.line_items || []).map(li => (
                      <ListItem key={li.id} sx={{ bgcolor: 'white', mb: 1, borderRadius: 1, border: '1px solid #E5E7EB', px: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Typography variant="h6" sx={{ minWidth: 56, textAlign: 'center', color: '#111827' }}>{li.quantity}x</Typography>
                          <IconButton onClick={() => openPreview((li.image && li.image.src) || '')} sx={{ p: 0.5, mx: 1 }}>
                            <Avatar variant="rounded" src={(li.image && li.image.src) || ''} alt={li.name} sx={{ width: 64, height: 64, m: 0.5 }} />
                          </IconButton>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ color: '#1F2937' }}>{li.name}</Typography>
                            {/* Show item options (e.g. size) before SKU */}
                            {Array.isArray(li.meta_data) && li.meta_data.length > 0 && (
                              <Box sx={{ mt: 0.5, display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                                {li.meta_data
                                  .filter(m => {
                                    if (!m) return false;
                                    const name = String(m.display_key ?? m.key ?? '');
                                    if (!name || name.startsWith('_')) return false;
                                    const rawVal = (m.display_value !== undefined && m.display_value !== null) ? m.display_value : (m.value !== undefined ? m.value : '');
                                    const valStr = (typeof rawVal === 'object') ? JSON.stringify(rawVal) : String(rawVal);
                                    const val = valStr == null ? '' : valStr.trim();
                                    // skip options with empty/meaningless values
                                    if (!val || val === '{}' || val === '[]' || val === 'null') return false;
                                    return true;
                                  })
                                  .map((m, idx) => (
                                    <Chip
                                      key={`meta-${li.id}-${idx}`}
                                      label={`${m.display_key || m.key} : ${m.display_value || (typeof m.value === 'object' ? JSON.stringify(m.value) : m.value)}`}
                                      size="small"
                                      color="warning"
                                      variant="outlined"
                                    />
                                  ))}
                              </Box>
                            )}
                            <Typography variant="caption" color="text.secondary">SKU: {li.sku || '—'}</Typography>
                          </Box>
                          <Box sx={{ textAlign: 'right', minWidth: 140, ml: 2 }}>
                            <Typography variant="body2">Unit: {formatCurrency(li.price, selectedOrder)}</Typography>
                            <Typography sx={{ fontWeight: 800, color: '#111827' }}>{formatCurrency(li.total || (li.price * li.quantity), selectedOrder)}</Typography>
                          </Box>
                        </Box>
                      </ListItem>
                    ))}
                    {/* Fee lines: show invoiced fees (card messages, wrapping, etc.) */}
                    {(selectedOrder.fee_lines || []).map(f => (
                      <ListItem key={`fee-${f.id}`} sx={{ bgcolor: 'white', mb: 1, borderRadius: 1, border: '1px solid #E5E7EB', px: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                          <Typography variant="h6" sx={{ minWidth: 56, textAlign: 'center', color: '#111827' }}>—</Typography>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ color: '#1F2937' }}>{f.name || 'Fee'}</Typography>
                            <Typography variant="caption" color="text.secondary">Fee</Typography>
                          </Box>
                          <Box sx={{ textAlign: 'right', minWidth: 140, ml: 2 }}>
                            <Typography variant="body2">Amount: {formatCurrency(f.amount || f.total, selectedOrder)}</Typography>
                            <Typography sx={{ fontWeight: 800, color: '#111827' }}>{formatCurrency(f.total || f.amount, selectedOrder)}</Typography>
                          </Box>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>

              {/* Totals summary (full width) */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ borderColor: '#E5E7EB' }}>
                  <CardContent>
                    <Typography variant="h6">Summary</Typography>
                    <Divider sx={{ my: 1 }} />
                    {(() => { const t = computeOrderTotals(selectedOrder); return (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>Items subtotal</Typography><Typography>{formatCurrency(t.subtotal, selectedOrder)}</Typography></Box>
                        {t.feesTotal && Number(t.feesTotal) !== 0 && <Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>Fees</Typography><Typography>{formatCurrency(t.feesTotal, selectedOrder)}</Typography></Box>}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>Shipping</Typography><Typography>{formatCurrency(t.shipping, selectedOrder)}</Typography></Box>
                        {selectedOrder.discount_total && Number(selectedOrder.discount_total) > 0 && <Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>Discount</Typography><Typography>-{formatCurrency(selectedOrder.discount_total, selectedOrder)}</Typography></Box>}
                        {selectedOrder.total_tax && Number(selectedOrder.total_tax) > 0 && <Box sx={{ display: 'flex', justifyContent: 'space-between' }}><Typography>Tax</Typography><Typography>{formatCurrency(selectedOrder.total_tax, selectedOrder)}</Typography></Box>}
                        <Divider sx={{ my: 1 }} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="h6">Grand Total</Typography>
                          <Typography variant="h5" sx={{ fontWeight: 800, color: '#1F2937' }}>{formatCurrency(t.total, selectedOrder)}</Typography>
                        </Box>
                      </Box>
                    ) })()}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </DialogContent>

        <Box sx={{ position: 'sticky', bottom: 0, bgcolor: '#FFFFFF', borderTop: '1px solid #E5E7EB', p: 2, display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {!selectedOrder || (selectedOrder && (internalOrdersMap && internalOrdersMap[selectedOrder.id])) ? (
              <Button
                variant="contained"
                color="primary"
                onClick={openStatusDialog}
                disabled={selectedOrder?.status === 'pending' && !canManagePendingPayments}
              >
                Update Status
              </Button>
            ) : (
              <Button variant="contained" color="primary" onClick={async () => {
                try {
                  const created = await InternalOrderService.createFromWoo(selectedOrder, null);
                  if (created && created.order) {
                    setInternalOrdersMap(prev => ({ ...(prev||{}), [selectedOrder.id]: created.order }));
                  }
                } catch (e) { console.error('createFromModal', e); alert('Failed to create order in local service'); }
              }}>Add to local service</Button>
            )}
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="text" startIcon={<PrintIcon />} onClick={() => printOrder(selectedOrder)}>Print</Button>
          </Box>
        </Box>
      </Dialog>

      <Dialog open={createOrderDialogOpen} onClose={closeCreateOrderDialog} maxWidth="md" fullWidth>
        <DialogTitle>Saisir les informations de la commande WooCommerce</DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Prénom"
                value={createOrderForm.first_name}
                onChange={(e) => handleCreateOrderFieldChange('first_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Nom"
                value={createOrderForm.last_name}
                onChange={(e) => handleCreateOrderFieldChange('last_name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse"
                value={createOrderForm.address_1}
                onChange={(e) => handleCreateOrderFieldChange('address_1', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Ville"
                value={createOrderForm.city}
                onChange={(e) => handleCreateOrderCityChange(e.target.value)}
              >
                {WC_MOROCCO_CITY_OPTIONS.map((option) => (
                  <MenuItem key={`${option.stateCode}-${option.city}`} value={option.city}>
                    {option.city}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Numéro de téléphone"
                value={createOrderForm.phone}
                onChange={(e) => handleCreateOrderFieldChange('phone', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="date"
                label="Date de livraison"
                value={createOrderForm.delivery_date}
                onChange={(e) => handleCreateOrderFieldChange('delivery_date', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Note"
                value={createOrderForm.note}
                onChange={(e) => handleCreateOrderFieldChange('note', e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Produits</Typography>
              <Autocomplete
                options={createProductOptions}
                loading={createProductLoading}
                inputValue={createProductSearch}
                filterOptions={(options) => options}
                getOptionLabel={(option) => option?.name || `#${option?.id || ''}`}
                onInputChange={(_event, value) => setCreateProductSearch(value)}
                onChange={(_event, value) => {
                  if (value) {
                    addProductToDraftOrder(value);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Rechercher un produit WooCommerce"
                    placeholder="Nom, SKU..."
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1, color: '#6B7280' }} />
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              {createOrderProducts.length ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Produit</TableCell>
                        <TableCell width={120}>Quantité</TableCell>
                        <TableCell width={140}>Prix</TableCell>
                        <TableCell width={120}>Total</TableCell>
                        <TableCell width={80}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {createOrderProducts.map((item) => (
                        <TableRow key={item.product_id}>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                              {item.image ? (
                                <Box
                                  component="img"
                                  src={item.image}
                                  alt={item.name}
                                  onClick={() => openPreview(item.image)}
                                  sx={{
                                    width: 52,
                                    height: 52,
                                    objectFit: 'cover',
                                    borderRadius: 1,
                                    border: '1px solid #E5E7EB',
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                  }}
                                />
                              ) : (
                                <Box
                                  sx={{
                                    width: 52,
                                    height: 52,
                                    borderRadius: 1,
                                    border: '1px solid #E5E7EB',
                                    bgcolor: '#F9FAFB',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#9CA3AF',
                                    fontSize: 12,
                                    flexShrink: 0,
                                  }}
                                >
                                  No img
                                </Box>
                              )}
                              <Box>
                                <Typography fontWeight={600}>{item.name}</Typography>
                                <Typography variant="caption" color="text.secondary">
                                  {item.sku || `#${item.product_id}`}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              size="small"
                              value={item.quantity}
                              onChange={(e) => updateDraftOrderProductQuantity(item.product_id, e.target.value)}
                              inputProps={{ min: 1 }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              size="small"
                              value={item.price}
                              onChange={(e) => updateDraftOrderProductPrice(item.product_id, e.target.value)}
                              inputProps={{ min: 0, step: '0.01' }}
                            />
                          </TableCell>
                          <TableCell>{formatCurrency((Number(item.price || 0) * Number(item.quantity || 1)), selectedOrder || {})}</TableCell>
                          <TableCell align="right">
                            <Button color="error" onClick={() => removeDraftOrderProduct(item.product_id)}>
                              Retirer
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Aucun produit ajouté.
                </Typography>
              )}
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1">Frais</Typography>
                <Button onClick={addDraftFeeLine}>Ajouter frais</Button>
              </Box>
              <Stack spacing={1.5}>
                {createOrderFees.map((fee) => (
                  <Grid container spacing={1} key={fee.id}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Nom du frais"
                        value={fee.name}
                        onChange={(e) => updateDraftFeeLine(fee.id, 'name', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        label="Montant"
                        value={fee.total}
                        onChange={(e) => updateDraftFeeLine(fee.id, 'total', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Button color="error" fullWidth onClick={() => removeDraftFeeLine(fee.id)}>
                        Retirer
                      </Button>
                    </Grid>
                  </Grid>
                ))}
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#F9FAFB', border: '1px solid #E5E7EB' }}>
                <Typography variant="subtitle2">Résumé</Typography>
                <Typography variant="body2">Produits: {createOrderProducts.length}</Typography>
                <Typography variant="body2">Sous-total produits: {formatCurrency(createOrderProductsTotal, selectedOrder || {})}</Typography>
                <Typography variant="body2">Frais: {formatCurrency(createOrderFeesTotal, selectedOrder || {})}</Typography>
                <Typography variant="body1" fontWeight={700}>
                  Total estimé: {formatCurrency(createOrderProductsTotal + createOrderFeesTotal, selectedOrder || {})}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCreateOrderDialog} disabled={createOrderSubmitting}>Annuler</Button>
          <Button variant="contained" onClick={submitCreateOrder} disabled={createOrderSubmitting}>
            {createOrderSubmitting ? 'Création...' : 'Enregistrer la commande'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={canManagePendingPayments && Boolean(createdOrderResult)} onClose={() => setCreatedOrderResult(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Commande WooCommerce créée</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Typography>
              {createdOrderResult?.id ? `Commande #${createdOrderResult.id} créée.` : 'Commande créée.'}
            </Typography>
            {createdOrderResult?.status === 'pending' && createdOrderResult?.payment_url && (
              <>
                <TextField
                  fullWidth
                  label="Lien de paiement"
                  value={createdOrderResult.payment_url}
                  InputProps={{ readOnly: true }}
                />
                <Stack direction="row" spacing={1}>
                  <Button variant="contained" startIcon={<ContentCopyIcon />} onClick={() => copyPaymentLink(createdOrderResult.payment_url)}>
                    Copier le lien
                  </Button>
                  <Button variant="outlined" startIcon={<OpenInNewIcon />} onClick={() => window.open(createdOrderResult.payment_url, '_blank')}>
                    Ouvrir
                  </Button>
                </Stack>
              </>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreatedOrderResult(null)}>Fermer</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={imagePrintDialogOpen} onClose={closeImagePrintDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Imprimer l'image client</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            {getPrintImageUrl(imagePrintOrder) ? (
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <Avatar variant="rounded" src={getPrintImageUrl(imagePrintOrder)} sx={{ width: 88, height: 88, bgcolor: '#F1F5F9' }}>
                  <ImageIcon />
                </Avatar>
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontWeight: 800 }}>Woo #{imagePrintOrder?.number || imagePrintOrder?.id}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-all' }}>
                    {getPrintImageUrl(imagePrintOrder)}
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Typography color="text.secondary">Aucune image client disponible.</Typography>
            )}

            <TextField
              select
              label="Imprimante"
              value={imagePrintPrinterUid}
              onChange={(event) => {
                setImagePrintPrinterUid(event.target.value);
                setImagePrintPaperName('');
              }}
              fullWidth
            >
              {printerOptions.map((printer) => (
                <MenuItem key={printer.printer_uid} value={printer.printer_uid}>
                  {printer.name} - {printer.computer_name || 'Poste'} {printer.is_default ? '(par défaut)' : ''}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              label="Format papier"
              value={imagePrintPaperName}
              onChange={(event) => setImagePrintPaperName(event.target.value)}
              fullWidth
              helperText="Si aucun format n'est choisi, le backend utilise un format ticket 80mm par défaut."
            >
              <MenuItem value="">Automatique</MenuItem>
              {(selectedImagePrintPrinter?.paper_sizes || []).map((paper) => (
                <MenuItem key={`${paper.name}-${paper.width}-${paper.height}`} value={paper.name}>
                  {paper.name || `${paper.width} x ${paper.height}`}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeImagePrintDialog} disabled={imagePrintSubmitting}>Annuler</Button>
          <Button
            variant="contained"
            startIcon={<PrintIcon />}
            onClick={submitImagePrint}
            disabled={imagePrintSubmitting || !imagePrintPrinterUid || !getPrintImageUrl(imagePrintOrder)}
          >
            Envoyer à la queue
          </Button>
        </DialogActions>
      </Dialog>

      {/* Image preview dialog */}
        <Dialog open={previewOpen} onClose={closePreview} maxWidth="md">
          <Box sx={{ p: 2, bgcolor: '#fff' }}>
            {previewImage ? <img src={previewImage} alt="preview" style={{ maxWidth: '100%', maxHeight: '80vh', display: 'block', margin: '0 auto' }} /> : <Typography>No image</Typography>}
          </Box>
        </Dialog>

      {/* Bulk order update dialog */}
      <Dialog open={bulkDialogOpen} onClose={closeBulkDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Modifier {bulkSelectedOrders.length} commande(s)</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Le statut sera appliqué à toutes les commandes sélectionnées avec les mêmes contrôles que la modification unitaire.
            </Typography>
            <Autocomplete
              options={Object.keys(STATUS_LABELS)
                .filter((status) => bulkSelectedOrders.every((order) => canSetProductionStatus(order, status)))
                .map((status) => ({
                  value: status,
                  label: STATUS_LABELS[status] || status
                }))}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => <li {...props} key={option.value}>{option.label}</li>}
              value={bulkStatus ? { value: bulkStatus, label: STATUS_LABELS[bulkStatus] || bulkStatus } : null}
              onChange={(_, option) => handleBulkStatusChange(option?.value || '')}
              renderInput={(params) => <TextField {...params} label="Nouveau statut" />}
              disabled={bulkSubmitting}
            />

            {PRODUCTION_STATUSES.includes(bulkStatus) && (
              <TextField
                select
                fullWidth
                label="Magasin"
                value={bulkStoreId}
                onChange={(event) => setBulkStoreId(event.target.value)}
                disabled={bulkSubmitting}
              >
                {bulkStoresOptions.length > 0 ? bulkStoresOptions.map((store) => (
                  <MenuItem key={store.id || store.value} value={store.id || store.value}>
                    {store.label || store.name || store.id || store.value}
                  </MenuItem>
                )) : (
                  <MenuItem value={bulkStoreId}>{bulkStoreId ? 'Magasin par défaut' : 'Aucun magasin disponible'}</MenuItem>
                )}
              </TextField>
            )}

            {bulkStatus === 'delivery-inroute' && (
              <TextField
                select
                fullWidth
                label="Livreur"
                value={bulkDriverId}
                onChange={(event) => setBulkDriverId(event.target.value)}
                disabled={bulkSubmitting}
              >
                {bulkDriversOptions.length > 0 ? bulkDriversOptions.map((driver) => (
                  <MenuItem key={driver._id || driver.id} value={driver._id || driver.id}>
                    {[driver.name, driver.lastname].filter(Boolean).join(' ') || driver.email || driver.username || driver._id || driver.id}
                    {driver.phone ? ` - ${driver.phone}` : ''}
                  </MenuItem>
                )) : (
                  <MenuItem value="">Aucun livreur disponible</MenuItem>
                )}
              </TextField>
            )}

            {bulkSubmitting && (
              <Typography variant="body2" sx={{ fontWeight: 600, color: '#1D4ED8' }}>
                Traitement {bulkProgress.completed}/{bulkProgress.total}…
              </Typography>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeBulkDialog} disabled={bulkSubmitting}>Annuler</Button>
          <Button
            variant="contained"
            onClick={applyBulkStatusUpdate}
            disabled={
              bulkSubmitting ||
              !bulkStatus ||
              (PRODUCTION_STATUSES.includes(bulkStatus) && !bulkStoreId) ||
              (bulkStatus === 'delivery-inroute' && !bulkDriverId)
            }
          >
            {bulkSubmitting ? 'Mise à jour…' : 'Appliquer à la sélection'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Status update dialog */}
      <Dialog open={statusDialogOpen} onClose={closeStatusDialog} maxWidth="xs">
        <DialogTitle>Update order status</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={Object.keys(STATUS_LABELS)
              .filter((status) => !selectedOrder || canSetProductionStatus(selectedOrder, status))
              .map(s => ({ value: s, label: STATUS_LABELS[s] || s }))}
            getOptionLabel={(opt) => opt.label}
            renderOption={(props, option) => (<li {...props} key={option.value}>{option.label}</li>)}
            value={newStatus ? { value: newStatus, label: STATUS_LABELS[newStatus] || newStatus } : null}
            onChange={(e, val) => setNewStatus(val ? val.value : '')}
            renderInput={(params) => <TextField {...params} label="Status" variant="outlined" sx={{ mt: 1 }} />}
            fullWidth
            freeSolo={false}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeStatusDialog}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={async () => {
            if (!newStatus) return alert('Select a status');
            const skipConfirmStatuses = ['delivery-inroute', 'en-cours-de-produ', 'en-cours-prod-mp'];
            if (skipConfirmStatuses.includes(newStatus)) {
              // Directly proceed to next modal flow for these statuses
              closeStatusDialog();
              await confirmUpdateStatus();
            } else {
              setStatusConfirmOpen(true);
            }
          }}>Confirm</Button>
        </DialogActions>
      </Dialog>
      {/* Confirmation dialog to avoid using window.confirm (eslint) */}
      <Dialog open={statusConfirmOpen} onClose={() => setStatusConfirmOpen(false)}>
        <DialogTitle>Confirm status change</DialogTitle>
        <DialogContent>
          <Typography>Change status to "{STATUS_LABELS[newStatus] || newStatus}" ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusConfirmOpen(false)}>No</Button>
          <Button variant="contained" color="primary" onClick={async () => { setStatusConfirmOpen(false); await confirmUpdateStatus(); }}>Yes</Button>
        </DialogActions>
      </Dialog>
      {/* Store selection dialog for production statuses */}
      <Dialog open={storeDialogOpen} onClose={closeStoreDialog} maxWidth="sm">
        <DialogTitle>Send order to internal service</DialogTitle>
        <DialogContent>
          <TextField
            select
            fullWidth
            value={selectedStoreId || ''}
            onChange={e => setSelectedStoreId(e.target.value)}
            sx={{ mt: 1 }}
            disabled={sendingToInternal}
          >
            {storesOptions && storesOptions.length > 0 ? storesOptions.map(s => (
              <MenuItem key={s.id || s.value} value={s.id || s.value}>{s.label}</MenuItem>
            )) : (
              <MenuItem value={selectedStoreId || ''}>Default</MenuItem>
            )}
          </TextField>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>Select the Glovo store to add this order to. Defaults are preselected.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeStoreDialog} disabled={sendingToInternal}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={async () => { await sendToInternal(); }} disabled={sendingToInternal}>
            {sendingToInternal ? 'Sending...' : 'Send'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Driver assignment dialog for delivery-inroute */}
      <Dialog open={driverDialogOpen} onClose={closeDriverDialog} maxWidth="sm">
        <DialogTitle>Assign Driver</DialogTitle>
        <DialogContent>
          <TextField
            select
            fullWidth
            value={selectedDriverId || ''}
            onChange={e => setSelectedDriverId(e.target.value)}
            sx={{ mt: 1 }}
            disabled={assigningDriver}
          >
            {driversOptions && driversOptions.length > 0 ? driversOptions.map(u => (
              <MenuItem key={u._id || u.id} value={u._id || u.id}>{(u.name || '') + ' ' + (u.lastname || '')} {u.phone ? ` - ${u.phone}` : ''}</MenuItem>
            )) : (
              <MenuItem value="">Aucun chauffeur disponible</MenuItem>
            )}
          </TextField>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>Select a driver to assign this order before marking it as "Livraison en cours".</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDriverDialog} disabled={assigningDriver}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={async () => { await assignDriverAndUpdate(); }} disabled={assigningDriver}>
            {assigningDriver ? 'Assigning...' : 'Assign'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
